export const ru = {
    common: {
        save: 'Сохранить',
        cancel: 'Отмена',
        delete: 'Удалить',
        create: 'Создать',
        search: 'Поиск',
        logout: 'Выйти',
        loading: 'Загрузка…',
        edit: 'Редактировать',
        back: 'Назад',
        close: 'Закрыть',
        refresh: 'Обновить',
        upload: 'Загрузить',
        yes: 'Да',
        no: 'Нет',
        none: 'Нет',
        all: 'Все',
        of: 'из',
        actions: 'Действия',
        status: 'Статус',
        city: 'Город',
        country: 'Страна',
        language: 'Язык',
        title: 'Название',
        name: 'Имя',
        email: 'Email',
        password: 'Пароль',
        photo: 'Фото',
        cover: 'Обложка',
        media: 'Медиа',
        locales: 'Локали',
        details: 'Детали',
        overview: 'Обзор',
        constructor: 'Конструктор',
        review: 'Модерация',
        archive: 'Архив',
        approve: 'Одобрить',
        reject: 'Отклонить',
        saved: 'Сохранено',
        deleted: 'Удалено',
        created: 'Создано',
        updated: 'Обновлено',
        error: 'Ошибка',
        confirmDelete: 'Вы уверены, что хотите удалить это?',
        remove: 'Удалить',
        add: 'Добавить',
        clear: 'Очистить',
        clearSearch: 'Очистить поиск',
        filter: 'Фильтр',
        reset: 'Сбросить',
        open: 'Открыть',
        view: 'Просмотр',
        duplicate: 'Дублировать',
        import: 'Импорт',
        export: 'Экспорт',
        generate: 'Сгенерировать',
        sync: 'Синхронизировать',
        next: 'Далее',
        previous: 'Назад',
        empty: 'Пусто',
        required: 'Обязательно',
        optional: 'Необязательно',
        dragToReorder: 'Перетащите для изменения порядка',
        noResults: 'Ничего не найдено',
        tryAgain: 'Что-то пошло не так. Попробуйте ещё раз.',
        unsaved: 'Не сохранено',
        cannotBeUndone: 'Это действие нельзя отменить.',
        confirmSwitchTab: 'На этой вкладке есть несохранённые изменения. Всё равно переключиться?',
        confirmCloseUnsaved: 'Есть несохранённые изменения. Всё равно закрыть?',
        discardChanges: 'Отменить несохранённые изменения?',
        address: 'Адрес',
        description: 'Описание',
        knownFor: 'Известен(на) чем',
        category: 'Категория',
        fame: 'Известность',
        recognition: 'Признание',
        domain: 'Сфера',
        domains: 'Сферы',
        source: 'Источник',
        author: 'Автор',
        venue: 'Партнёр-площадка',
        quantity: 'Количество',
        comment: 'Комментарий',
        date: 'Дата',
        commission: 'Комиссия',
        promocode: 'Промокод',
        companyName: 'Название компании',
        contactName: 'Контактное лицо',
        avatar: 'Аватар',
        gallery: 'Галерея',
        url: 'Ссылка',
        key: 'Ключ',
        label: 'Подпись',
        value: 'Значение',
        kind: 'Тип',
        type: 'Тип',
        from: 'От',
        to: 'До',
        distance: 'Расстояние',
        duration: 'Длительность',
        timezone: 'Часовой пояс',
        select: 'Выбрать',
        selectAll: 'Выбрать все',
    },
    nav: {
        dashboard: 'Дашборд',
        cities: 'Каталог городов',
        quests: 'Городские квесты',
        routes: 'Аудиомаршруты',
        people: 'Исторические персоны',
        attractions: 'Достопримечательности',
        collections: 'Подборки',
        establishments: 'Заведения',
        districts: 'Районы',
        foods: 'Еда',
        authors: 'Авторы контента',
        venues: 'Партнёры-площадки',
        activities: 'Туры GetYourGuide',
        orders: 'Поставка буклетов',
        purchases: 'Продажи контента',
        reviews: 'Отзывы игроков',
        translations: 'Переводы',
        qa: 'Проверка правок',
        wiki: 'Wiki',
        users: 'Учётные записи',
    },
    enums: {
        purchaseProvider: {
            stripe: 'Stripe',
            iap: 'App Store / Play',
            cloudpayments: 'CloudPayments (.ru)',
        },
        purchaseScope: {
            route: 'Маршрут',
            quest: 'Квест',
            city: 'Пак города',
            pass: 'Пасс',
        },
        experienceReviewStatus: {
            pending: 'На модерации',
            approved: 'Одобрено',
            rejected: 'Отклонено',
        },
        experienceReviewSubject: {
            quest: 'Квест',
            route: 'Маршрут',
        },
        attractionReviewStatus: {
            approved: 'Одобрено',
            needReview: 'На проверке',
            rejected: 'Отклонено',
            rejected_mcp: 'Отклонено (MCP)',
        },
        personReviewStatus: {
            approved: 'Одобрено',
            needReview: 'На проверке',
            rejected: 'Отклонено',
            rejected_mcp: 'Отклонено (MCP)',
        },
        attractionCategory: {
            museum: 'Музей',
            temple_church: 'Храм / церковь',
            architecture_landmark: 'Архитектурная достопримечательность',
            palace_fortress: 'Дворец / крепость',
            archaeological_site: 'Археологический памятник',
            park_garden: 'Парк / сад',
            viewpoint: 'Смотровая площадка',
            square: 'Площадь',
            street_district: 'Улица / квартал',
            bridge: 'Мост',
            market: 'Рынок',
            cemetery_necropolis: 'Кладбище / некрополь',
            theater_cultural_venue: 'Театр / культурная площадка',
            monument_memorial: 'Памятник / мемориал',
            canal_waterfront: 'Канал / набережная',
            transport_landmark: 'Транспортный объект',
            stadium: 'Стадион',
            zoo_aquarium: 'Зоопарк / аквариум',
            gallery: 'Галерея',
            entertainment: 'Развлечения',
            natural_site: 'Природный объект',
            unusual_place: 'Необычное место',
        },
        attractionFame: {
            icon: 'Символ города',
            well_known: 'Известное',
            offbeat: 'Нетривиальное',
            hidden_gem: 'Скрытая жемчужина',
        },
        localeStatus: {
            empty: 'Пусто',
            generated: 'Сгенерировано',
            reviewed: 'Проверено',
        },
        attractionReadiness: {
            none: 'Не отобрано',
            triaged: 'Отобрано',
            passport: 'Паспорт',
            scouted: 'Разведано',
            light: 'Лёгкая карточка',
            base: 'Банк фактов',
            brief: 'Бриф',
            guide: 'Тексты',
            audio: 'Аудио',
        },
        attractionTier: {
            route: 'Маршрут',
            full: 'Полный рассказ',
            light: 'Лёгкая карточка',
            silent: 'Тихая рекомендация',
        },
        attractionScoutVerdict: {
            rich: 'богато',
            medium: 'средне',
            poor: 'бедно',
        },
        attractionReadinessCheck: {
            triage: 'триаж',
            passport: 'паспорт',
            scout: 'разведка',
            lightCard: 'лёгкая карточка',
            factBank: 'банк фактов',
            photos: 'фото',
            coordinates: 'координаты',
            interest: 'оценки интереса',
            brief: 'утверждённый сценарный бриф',
            guideTalk: 'рассказ гида',
            emojiFacts: 'карточки и факт',
            hours: 'часы',
            visitDetails: 'билет и формат',
            audio: 'аудиогид',
        },
        establishmentKind: {
            spot: 'Одно место',
            cluster: 'Площадка',
        },
        establishmentOffer: {
            coffee: 'Кофе',
            breakfast: 'Завтрак',
            food: 'Еда',
            bar: 'Бар',
            wine: 'Вино',
            music: 'Музыка',
            market: 'Маркет',
        },
        establishmentStatus: {
            draft: 'Черновик',
            published: 'В гайды',
            closed: 'Закрыто',
        },
        establishmentLocaleStatus: {
            empty: 'Черновик текста',
            ready: 'Готово для гайда',
        },
        guideStatus: {
            draft: 'Черновик',
            published: 'В путеводителе',
        },
        guideLocaleStatus: {
            empty: 'Черновик текста',
            ready: 'Готово для гайда',
        },
        establishmentPrice: {
            1: '1 · повседневное',
            2: '2 · средний счёт',
            3: '3 · дороже обычного',
            4: '4 · особый выход',
        },
        intakeCuisine: {
            thai: 'Тайская кухня',
            isan: 'Исан',
            chinese: 'Китайская кухня',
            indian: 'Индийская кухня',
            israeli: 'Израильская кухня',
            japanese: 'Японская кухня',
            italian: 'Итальянская кухня',
            french: 'Французская кухня',
            mexican: 'Мексиканская кухня',
            bakery: 'Выпечка',
            seafood: 'Морепродукты',
            vegetarian: 'Без мяса',
            'street-food': 'Стритфуд',
        },
        intakeDrink: {
            cocktails: 'Коктейли',
            'craft-beer': 'Крафтовое пиво',
            'natural-wine': 'Натуральное вино',
            gin: 'Джин',
            agave: 'Агава',
            roaster: 'Своя обжарка',
        },
        intakeRoom: {
            terrace: 'Терраса',
            rooftop: 'Крыша',
            upstairs: 'Наверху',
            counter: 'У стойки',
            listening: 'Слушают',
        },
        intakePets: {
            no: 'Нет',
            yes: 'Да',
            outside: 'Только снаружи',
        },
        intakeAge: {
            all: 'Любой возраст',
        },
        intakeBooking: {
            'walk-in': 'Без брони',
            helps: 'Бронь помогает',
            required: 'Нужна бронь',
        },
        intakeCash: {
            no: 'Нет',
            yes: 'Да',
        },
        weekday: {
            mon: 'Пн',
            tue: 'Вт',
            wed: 'Ср',
            thu: 'Чт',
            fri: 'Пт',
            sat: 'Сб',
            sun: 'Вс',
        },
        attractionRouteRole: {
            anchor: 'Обязательная',
            primary: 'Сильная остановка',
            connector: 'Проходной ориентир',
            optional: 'Дополнительная',
            detour: 'Заход в сторону',
        },
        attractionTheme: {
            history: 'История',
            architecture: 'Архитектура',
            art: 'Искусство',
            religion: 'Религия',
            nature: 'Природа',
            food: 'Еда',
            shopping: 'Шопинг',
            unusual: 'Необычное',
            panorama: 'Панорамы',
            city_life: 'Городская жизнь',
            culture: 'Культура',
            entertainment: 'Развлечения',
            traditions: 'Местные традиции',
        },
        attractionScenario: {
            with_kids: 'С детьми',
            free: 'Бесплатно',
            rainy: 'В дождь',
            evening: 'Вечером',
            short_visit: 'Короткий визит',
            long_visit: 'Долгий визит',
            photogenic: 'Для фото',
            first_visit: 'Первый визит',
            hidden_gem: 'Скрытая жемчужина',
            local: 'Местная жизнь',
            sunset: 'На закате',
        },
        attractionAudioPotential: {
            strong: 'Сильная история',
            medium: 'Хватит на рассказ',
            low: 'Слабая история',
            none: 'Не для аудио',
            unassessed: 'Ещё не оценено',
        },
        collectionKind: {
            must_see: 'Что посмотреть',
            first_visit: 'Первый визит',
            one_day: 'За один день',
            with_kids: 'С детьми',
            for_couples: 'Вдвоём',
            unusual: 'Необычные места',
            photogenic: 'Для фото',
            viewpoints: 'Панорамы',
            free: 'Бесплатно',
            rainy_day: 'В дождь',
            evening: 'Вечером',
            sunset: 'На закате',
            hidden_gems: 'Скрытые жемчужины',
            local: 'Как живут местные',
            museums_and_art: 'Музеи и искусство',
            temples: 'Храмы',
            walks: 'Где погулять',
            architecture: 'Архитектура',
            history: 'История',
            audio: 'Аудиопрогулки',
            short_visit: 'Короткая остановка',
            long_visit: 'Надолго',
            shopping: 'Шопинг',
            food: 'Еда',
        },
        attractionIndoorOutdoor: {
            indoor: 'В помещении',
            outdoor: 'На улице',
            mixed: 'Смешанный',
        },
        funFactKind: {
            fact: 'Факт',
            legend: 'Легенда',
        },
        personRecognition: {
            world: 'Мировая',
            local: 'Локальная',
        },
        personDomain: {
            music: 'Музыка',
            literature: 'Литература',
            visual_art: 'Изобразительное искусство',
            politics: 'Политика',
            architecture: 'Архитектура',
            acting: 'Актёрское искусство',
            science: 'Наука',
            sport: 'Спорт',
            film: 'Кино',
        },
        personFactKind: {
            bio: 'Биография',
            anecdote: 'История из жизни',
            work: 'Произведение',
            quote: 'Цитата',
            place: 'Место',
        },
        cityQuestStatus: {
            draft: 'Черновик',
            need_review: 'На проверке',
            rejected: 'Отклонён',
            ready: 'Готов',
            paused: 'На паузе',
        },
        cityQuestDisplayType: {
            scavenger_hunt: 'Городской квест',
            walking_tour: 'Прогулка с гидом',
            ghost_tour: 'Мистическая прогулка',
        },
        readyRouteStatus: {
            draft: 'Черновик',
            need_review: 'На проверке',
            rejected: 'Нужны правки',
            published: 'Опубликован',
        },
        readyRouteGuideType: {
            first_visit: 'Впервые в городе',
            scenic: 'Красивая прогулка',
            historical: 'Исторический',
        },
        portalPartnerStatus: {
            new: 'Новый',
            invite_sent: 'Приглашение отправлено',
            landing_opened: 'Открыл лендинг',
            registered: 'Зарегистрирован',
            has_orders: 'Есть заказы',
            closed: 'Закрыт',
            blocked: 'Заблокирован',
            rejected: 'Отклонён',
        },
        materialOrderStatus: {
            new: 'Новый',
            processing: 'В обработке',
            shipped: 'Отправлен',
            done: 'Выполнен',
            canceled: 'Отменён',
        },
        portalPartnerType: {
            author: 'Автор',
            venue: 'Партнёр-площадка',
        },
        artifactKind: {
            artwork: 'Произведение искусства',
            manuscript: 'Рукопись',
            plaque: 'Табличка',
            relic: 'Реликвия',
            sculpture_detail: 'Деталь скульптуры',
            exhibit: 'Экспонат',
            other: 'Другое',
        },
        challengeType: {
            count: 'Счёт',
            riddle: 'Загадка',
            observation: 'Наблюдение',
            choice: 'Выбор',
            anagram: 'Анаграмма',
            photo: 'Фото',
            time_dynamic: 'Динамика по времени',
            sensor: 'Сенсор',
            cipher: 'Шифр',
            ar_hunt: 'AR-охота',
        },
        sensorKind: {
            blow: 'Подуть',
            shake: 'Потрясти',
            tilt: 'Наклонить',
            compass: 'Компас',
        },
        cipherKind: {
            caesar: 'Колесо Цезаря',
            symbol_map: 'Таблица символов',
        },
        dynamicAnswerRule: {
            server_compares_submitted_time_to_local_time: 'Введённое время против местного',
            server_accepts_current_hour_figure_number_on_12h_cycle:
                'Фигура текущего часа (12-часовой цикл)',
        },
        routeEventType: {
            message: 'Сообщение',
            theft_bonus: 'Бонус за кражу',
            timed_challenge: 'Задание на время',
            gps_chase: 'GPS-погоня',
        },
        translationStatus: {
            not_ready: 'Не готово',
            waiting: 'Ожидание',
            need_check: 'Нужна проверка',
            ready: 'Готово',
            skipped: 'Пропущено',
        },
        countries: {
            it: 'Италия',
            ch: 'Швейцария',
            lv: 'Латвия',
            ee: 'Эстония',
            lt: 'Литва',
            cz: 'Чехия',
            pl: 'Польша',
            hu: 'Венгрия',
            at: 'Австрия',
            sk: 'Словакия',
            hr: 'Хорватия',
            pt: 'Португалия',
            es: 'Испания',
            gr: 'Греция',
            ru: 'Россия',
            de: 'Германия',
            fr: 'Франция',
            gb: 'Великобритания',
            nl: 'Нидерланды',
            ie: 'Ирландия',
            dk: 'Дания',
            se: 'Швеция',
            be: 'Бельгия',
            is: 'Исландия',
            tr: 'Турция',
            th: 'Таиланд',
            cn: 'Китай',
            my: 'Малайзия',
            vn: 'Вьетнам',
            hk: 'Гонконг',
            mo: 'Макао',
            by: 'Беларусь',
            ge: 'Грузия',
            jp: 'Япония',
            am: 'Армения',
        },
        contentLanguage: {
            ru: 'Русский',
            en: 'Английский',
            it: 'Итальянский',
            de: 'Немецкий',
            pl: 'Польский',
            es: 'Испанский',
            fr: 'Французский',
        },
        capability: {
            view: 'Просмотр',
            text: 'Текст',
            edit: 'Редактирование',
            delete: 'Удаление',
        },
        questSource: {
            all: 'Все',
            partner: 'Партнёр',
            admin: 'Админ',
        },
    },
    pages: {
        login: {
            title: 'Вход',
            subtitle: 'Админ-панель Routellers — управление городами, квестами и партнёрами.',
            email: 'Email',
            emailPlaceholder: 'you@routellers.com',
            password: 'Пароль',
            submit: 'Войти',
            invalidEmail: 'Введите корректный email',
            passwordRequired: 'Введите пароль',
        },
        dashboard: {
            title: 'Дашборд',
            sales: {
                title: 'Продажи',
                week: 'За 7 дней',
                month: 'В этом месяце',
                purchases: 'Оплачено',
                refunded: 'Возвраты',
                openPurchases: 'Все покупки',
            },
            inbox: {
                title: 'Требует внимания',
                items: {
                    questsNeedReview: 'Квесты на проверке',
                    routesNeedReview: 'Маршруты на проверке',
                    attractionsNeedReview: 'Достопримечательности на проверке',
                    peopleNeedReview: 'Персоны на проверке',
                    reviewsPending: 'Отзывы игроков',
                    ordersOpen: 'Поставка буклетов',
                    venuesNew: 'Новые площадки',
                },
            },
            catalog: {
                title: 'Каталог',
                cities: 'Города',
                citiesReady: '{{ready}} готовы к Routellers из {{total}}',
                quests: 'Квесты',
                routes: 'Маршруты',
                attractions: 'Достопримечательности',
                people: 'Персоны',
            },
        },
        cities: {
            title: 'Каталог городов',
            create: 'Создать',
            searchPlaceholder: 'Поиск городов',
            columns: {
                id: 'ID',
                city: 'Город',
                country: 'Страна',
                routellers: 'Routellers',
                roadmap: 'Дорожная карта',
            },
            ready: 'Готов',
            hidden: 'Скрыт',
            earlyAccess: 'Ранний доступ',
            priority: 'Приоритет',
            empty: 'Города не найдены.',
            fallbackSuffix: '— показаны приоритетные города как запасной вариант.',
        },
        cityDetail: {
            back: 'Города',
            unsaved: 'Не сохранено',
            openOnSite: 'Открыть город на сайте',
            readyBadge: 'Routellers',
            earlyAccessBadge: 'Ранний доступ',
            tabs: {
                overview: 'Обзор',
                routes: 'Маршруты',
                locales: 'Локали',
                hero: 'Хиро-блок',
                story: 'История',
                practical: 'Практическое',
                faq: 'Вопросы',
                seo: 'SEO',
                guide: 'Путеводитель',
            },
            map: {
                places: 'Места',
                cafes: 'Кафе',
                summary: 'Районы {{districts}} · Маршруты {{routes}}',
                untitledRoute: 'Маршрут {{id}}',
                untitledDistrict: 'Район',
                noLine: 'нет линии',
                noOutline: 'без контура',
                empty: 'Районов и маршрутов на карте пока нет.',
                leafletFailed: 'Не удалось загрузить карту.',
                inRoute: 'В маршруте',
                notInRoute: 'Не в маршруте',
                pin: {
                    nutshell: 'Коротко',
                    funFact: 'Интересный факт',
                    lookFor: 'На что смотреть',
                    story: 'Рассказ',
                    people: 'Люди',
                    routes: 'Маршруты',
                    free: 'Вход свободный',
                    ticket: 'Нужен билет',
                    booking: 'Нужна запись',
                    family: 'Можно с детьми',
                    rain: 'Можно в дождь',
                    night: 'Можно вечером',
                    duration: 'Около {{minutes}} мин',
                    closed: 'закрыто',
                    find: 'Как найти',
                    since: 'С {{year}} года',
                },
            },
            guide: {
                lede: 'Районы и еда живут здесь, по одному языку. Кнопка заполняет пустые поля: часы, цену, запись и короткие тексты. Уже написанное не трогает.',
                refresh: 'Обновить данные',
                running: 'Собираем часы, цены и запись. Обычно это несколько минут.',
                refreshConfirmTitle: 'Обновить данные города?',
                refreshConfirmBody:
                    'Соберём районы, тексты районов, еду, часы, цену и нужна ли запись. Заполняются только пустые поля. Аудио не меняется.',
                refreshUnsaved: 'Несохранённый текст на этом экране будет перечитан с сервера.',
                force: 'Заменить уже собранные факты',
                forceHint:
                    'Часы, цены, флаги и абзацы путеводителя. Тексты аудио останутся как есть.',
                run: 'Обновить',
                districts: 'Районы',
                food: 'Еда',
                readyCount: 'На этом языке готовы {{ready}} из {{total}}',
                searchDistricts: 'Найти район',
                searchFoods: 'Найти блюдо',
                addPlaceholder: 'Название района',
                addFoodPlaceholder: 'Название блюда',
                add: 'Добавить',
                emptyDistricts:
                    'Районов пока нет. Обновление данных соберёт их из подписей мест и открытых источников. Можно добавить район вручную.',
                emptyFoods: 'Блюд пока нет. Обновление данных предложит их по заведениям города.',
                name: 'Название для гостя',
                portrait: 'Характер',
                portraitHint: 'Какой район на прогулке. Один абзац.',
                why: 'Зачем идти',
                whyHint: 'Что здесь есть такого, чего нет в соседнем районе.',
                stay: 'Где остановиться',
                stayHint: 'Кому район подходит как база. Без списка отелей.',
                pitch: 'Что это',
                pitchHint: 'Один абзац: что за еда и зачем её здесь едят.',
                textReady: 'Текст этого языка готов',
                textReadyHint: 'Готовому тексту нужны название и хотя бы один абзац.',
                unsaved: 'Есть несохранённый текст',
                unsavedTitle: 'Сохранить текст?',
                discard: 'Не сохранять',
                service: 'Служебное',
                serviceHint:
                    'Гость этого не видит. На сайте район появится, когда текст готов и включена публикация.',
                canonical: 'Каноническое имя',
                latitude: 'Широта',
                longitude: 'Долгота',
                publish: 'Показывать на сайте',
                remove: 'Удалить район',
                removeConfirm:
                    'Удалить район? Места останутся в городе, снимется только связь с районом.',
                removeFood: 'Удалить блюдо',
                removeFoodConfirm: 'Убрать это блюдо из путеводителя?',
                district: 'Район',
                tables: 'Где есть',
                order: 'Что заказать на этом языке',
                addTable: 'Добавить место',
                pickTable: 'Заведение',
                noTables: 'Пока ни одного места. Блюдо можно сохранить и без них.',
                coordsHint: 'Широту и долготу задают вместе.',
                publishNeedsText: 'Сначала отметьте готовым текст хотя бы одного языка.',
                saved: 'Сохранено',
                saveHint:
                    'Эта кнопка сохраняет район или блюдо. Кнопка внизу страницы сохраняет карточку города.',
                reportTitle: 'Что заполнилось',
                reportDistricts: 'Районы: создано {{created}}, с новым текстом {{filled}}',
                reportPlaces: 'Места: обновлено {{updated}}, ещё без данных {{remaining}}',
                reportTables: 'Заведения: обновлено {{updated}}, ещё без данных {{remaining}}',
                reportFoods: 'Блюда: создано {{created}}',
                reportCity: 'Тексты приезда: {{count}}',
            },
            identity: {
                title: 'Идентичность',
                description: 'Базовая запись города. Локализованные названия — на вкладке Локали.',
                titleLabel: 'Название',
                country: 'Страна',
                readyToLaunch: 'Готов к запуску',
                earlyAccess: 'Ранний доступ',
                earlyAccessHint:
                    'Маршруты, квесты и пакеты остаются на витрине. Вместо оплаты — «Скоро будет доступно», пока галочка включена.',
                coordinates: 'Координаты (только чтение): {{coords}}',
            },
            catalogPhoto: {
                title: 'Фото для каталога',
                description:
                    'Изображение карточки на главной и запасной вариант на странице города.',
            },
            hubImages: {
                title: 'Картинки на главной',
                description:
                    'Отдельная картинка для каждого пункта на экране города. Если не загружена — в приложении остаётся стандартная иллюстрация.',
                route: 'Прогулки с аудиогидом',
                quest: 'Разгадай тайны города',
                free: 'Собери свой маршрут',
                people: 'По следам великих',
                activity: 'Чем заняться',
            },
            heroVideo: {
                title: 'Хиро-видео',
                description:
                    'Не зависит от языка. Предпочтительно AV1 + H.264 для запасного варианта в Safari.',
                av1: 'AV1',
                h264: 'H.264',
                duration: 'Длительность (сек)',
            },
            heroStill: {
                title: 'Хиро-заставка',
                description: 'Кадр постера и обрезка для кинематографичного хиро-блока.',
                poster: 'Постер',
                focus: 'Фокус (object-position)',
                focusPlaceholder: 'center 58%',
            },
            displayNames: {
                title: 'Отображаемые названия',
                description: '{{lang}} — каталог игрока, «открыть далее» и карточки города.',
                titleLabel: 'Название',
                inTitle: 'Форма «в»',
                inTitleHint: 'Склонение, используемое в формулировках вида «в Комо».',
                nearTitle: 'Форма «около»',
                nearTitleHint: 'Склонение, используемое в формулировках вида «около Комо».',
            },
            heroHeadline: {
                title: 'Заголовок',
                description: '{{lang}} — надзаголовок и курсивная фраза над заголовком H1.',
                region: 'Надзаголовок региона',
                regionHint: 'Над H1, например: озеро Комо · Ломбардия, Италия',
                punch: 'Акцентная фраза',
                punchHint: 'Курсивная вторая строка заголовка H1',
            },
            heroLede: {
                title: 'Лид-абзац',
                description: '{{lang}} — короткая строка поверх хиро-видео.',
                lede: 'Лид-абзац',
            },
            storyIntro: {
                title: 'Вступление',
                description: '{{lang}} — вступительный абзац под хиро-блоком.',
                opening: 'Вступительный абзац',
            },
            storyChapters: {
                title: 'Главы',
                description: '{{lang}} — упорядоченные блоки истории под вступлением.',
                chapter: 'Глава {{n}}',
                addChapter: 'Добавить главу',
                chapterTitle: 'Название',
                chapterBody: 'Текст',
            },
            practicalFacts: {
                title: 'Факты',
                description:
                    '{{lang}} — практические пункты (как добраться, лучшие месяцы и т.д.).',
                fact: 'Факт {{n}}',
                addFact: 'Добавить факт',
                label: 'Подпись',
                value: 'Значение',
            },
            faq: {
                title: 'Вопросы',
                description: '{{lang}} — вопросы и ответы на странице города.',
                question: 'Вопрос {{n}}',
                addQuestion: 'Добавить вопрос',
                questionLabel: 'Вопрос',
                answer: 'Ответ',
            },
            seoSearch: {
                title: 'Поиск',
                description: '{{lang}} — метаописание для результатов поиска.',
                metaDescription: 'Метаописание',
            },
            partnerPitch: {
                title: 'Питч для партнёров',
                description: '{{lang}} — фраза для этого города на странице для отелей.',
                hotelPitch: 'Питч для отелей-партнёров',
            },
            arrival: {
                arrival: 'Как добраться',
                arrivalHint: 'Как гость попадает в город и как из него уезжает.',
                gettingAround: 'Как передвигаться',
                gettingAroundHint: 'Как двигаться, когда уже на месте.',
                commonMistake: 'Частая ошибка',
                commonMistakeHint: 'Что гости обычно делают не так.',
                howLong: 'Сколько дней',
                howLongHint: 'Одно предложение.',
                whenToGo: 'Когда ехать',
                whenToGoHint:
                    'Один абзац: когда ехать и когда город неудобен. Без таблицы климата.',
                money: 'Деньги',
                moneyHint: 'Одна строка: карта или нал, чаевые. Без цен.',
                festival: 'Праздник',
                festivalHint: 'Одна-две фразы, если дата меняет визит. Иначе пусто.',
            },
            saveCity: 'Сохранить город',
            deleteConfirm:
                'Удалить город #{{id}} ({{title}})?\n\nМожно удалить только пустой город.',
            titleCountryRequired: 'Название и страна обязательны.',
            saved: 'Город сохранён.',
            deleted: 'Город удалён.',
        },
        quests: {
            title: 'Городские квесты',
            create: 'Создать',
            searchPlaceholder: 'Поиск по ключу или названию',
            statusAll: 'Все статусы',
            sourceAll: 'Все источники',
            partner: 'Партнёр',
            admin: 'Админ',
            columns: {
                quest: 'Квест',
                city: 'Город',
                locales: 'Локали',
                stops: 'Точки',
                source: 'Источник',
                status: 'Статус',
            },
            empty: 'Нет квестов, подходящих под эти фильтры.',
        },
        routes: {
            title: 'Аудиомаршруты',
            create: 'Создать',
            searchPlaceholder: 'Поиск маршрутов',
            statusAll: 'Все статусы',
            openVoiceover: 'Открыть скрипт озвучки',
            columns: {
                route: 'Маршрут',
                city: 'Город',
                locales: 'Локали',
                stops: 'Точки',
                author: 'Автор',
                status: 'Статус',
            },
            published: 'Опубликован',
            draft: 'Черновик',
            empty: 'Маршруты не найдены.',
        },
        people: {
            title: 'Исторические персоны',
            create: 'Создать',
            searchPlaceholder: 'Поиск по имени',
            statusAll: 'Все статусы',
            domainAll: 'Все сферы',
            fameAll: 'Любая известность',
            withoutPhoto: 'Без фото',
            columns: {
                name: 'Имя',
                city: 'Город',
                locales: 'Локали',
                domains: 'Сферы',
                fame: 'Известность',
                review: 'Модерация',
            },
            empty: 'Персоны не найдены.',
        },
        attractions: {
            title: 'Достопримечательности',
            create: 'Создать',
            searchPlaceholder: 'Название или текст на любом языке',
            viewLabel: 'Вид достопримечательностей',
            listView: 'Список',
            mapView: 'Карта',
            mapCount: 'Точек на карте: {{count}}',
            mapLimit: 'Показаны первые 500. Приблизьте карту или уточните фильтры.',
            mapEmpty: 'В этой области нет достопримечательностей по выбранным фильтрам.',
            mapRetry: 'Повторить',
            statusAll: 'Все статусы',
            readinessAll: 'Все уровни',
            categoryAll: 'Все типы',
            themeAll: 'Все интересы',
            scenarioAll: 'Все ситуации',
            audioAll: 'Любая аудиоистория',
            mustSeeAll: 'Любая ценность',
            mustSeeHigh: 'Must-see 8+',
            storyRejects: 'Отказы из-за слабой истории',
            storyRejectsEmpty: 'В этом городе таких отказов нет.',
            storyRejectsHint: 'Карточки остаются отклонёнными, пока их не вернут поимённо.',
            briefDraft: 'Бриф: черновик',
            approveBrief: 'утвердить бриф',
            completeBrief: 'дополнить бриф',
            readinessNext: 'Дальше: {{items}}',
            readinessDone: 'Цель достигнута',
            readinessHelp: {
                all: 'Фильтр по последнему полностью пройденному этапу подготовки. Этапы выполняются последовательно.',
                none: 'Ещё не завершён первый этап: отбор места и наличие координат.',
                triaged:
                    'Место прошло отбор и имеет координаты. Следующий этап — заполнить паспорт.',
                passport:
                    'Заполнены фото, сведения о посещении и оценки интереса. Это ещё не готовый рассказ.',
                scouted:
                    'Оценён материал для будущей истории; наличие полного банка фактов также закрывает этот этап.',
                light: 'Одобрена короткая карточка или опубликована самостоятельная программа посещения. Для лёгкой карточки это конечная цель.',
                base: 'Собран банк фактов: не менее 5 после завершённого исследования или не менее 12 без него. Утверждение сценарного брифа — отдельный этап.',
                brief: 'Редактор утвердил сценарный бриф: есть обещание рассказа, его сюжетная линия и выбранные факты. Сохранённый черновик этот этап не закрывает.',
                guide: 'Заполнены русский рассказ гида, карточки и бонусный факт, часы и сведения о посещении. Аудиозапись проверяется следующим этапом.',
                audio: 'Есть русская аудиозапись рассказа, и все предыдущие этапы выполнены. Это не подтверждает озвучку других языков.',
            },
            help: {
                status: 'Статус редакторской модерации места: на проверке, одобрено или отклонено. Автоматические отказы скрыты, пока их статус не выбран явно. Одобрение места само по себе не означает готовность текстов, аудио или публикацию.',
                readiness:
                    'Последний полностью пройденный этап подготовки карточки. Этап засчитывается после всех предыдущих; сохранённый черновик брифа ещё требует утверждения. Для лёгких карточек и тихих рекомендаций цель короче.',
                theme: 'Темы, к которым относится место: история, архитектура, искусство и другие интересы. Фильтр помогает собрать места под тему прогулки.',
                scenario:
                    'Ситуация путешественника, для которой подходит место: короткая остановка, прогулка с детьми, скрытые жемчужины и другие сценарии.',
                audio: 'Насколько материала о месте хватает для интересного аудиорассказа. Учитывается оценка редактора, а при её отсутствии — результат разведки. Это потенциал истории, а не наличие готового аудио.',
                mustSee:
                    'Редакторская оценка важности места для первого знакомства с городом, от 1 до 10. «Must-see 8+» оставляет оценки 8–10. Важность места и сила его аудиоистории оцениваются отдельно.',
                storyRejects:
                    'Показывает ранее отклонённые при автоматическом отборе места выбранного города, где в причине отказа указана слабая история для аудио. Это кандидаты на ручной пересмотр: нажатие только открывает список и не восстанавливает карточки. Сначала выберите город.',
                progress:
                    'Пройденные этапы подготовки по порядку, например 4/7. Следующий шаг показывает, чего не хватает. Черновик брифа виден отдельно, но ступень брифа проходит после утверждения. Готовность считается по базовому русскому контенту.',
                locales:
                    'Ожидаемые языки контента для страны города. Яркий бейдж означает, что в этой локали заполнены зацепка и рассказ гида. Это не подтверждение проверки перевода или наличия аудиозаписи.',
            },
            columns: {
                title: 'Название',
                readiness: 'Прогресс',
                locales: 'Локали',
                category: 'Категория',
                mustSee: 'Must-see',
                review: 'Модерация',
            },
            empty: 'Достопримечательности не найдены.',
        },
        collections: {
            title: 'Подборки',
            lede: 'Редакционные списки. Набор типов один и тот же для всех городов. Подборка — не маршрут.',
            pickCity: 'Выберите город, чтобы править его подборки.',
            emptyKind: 'Ещё не создана',
            places: '{{count}} мест',
            name: 'Название',
            description: 'Описание',
            seoTitle: 'SEO-заголовок',
            seoDescription: 'SEO-описание',
            cover: 'URL обложки',
            addPlace: 'Добавить место',
            searchPlace: 'Поиск мест этого города',
            saved: 'Подборка сохранена',
        },
        districts: {
            title: 'Районы',
            subtitle: 'Части города, между которыми выбирает гость. На карте это зона.',
            create: 'Создать',
            backfill: 'Связать подписи',
            backfillConfirmCity: 'Собрать черновики районов из текстовых подписей этого города?',
            backfillConfirmAll: 'Собрать черновики районов из текстовых подписей всех городов?',
            backfillDone:
                'Создано {{created}}. Привязано мест: {{attractions}}, заведений: {{establishments}}.',
            searchPlaceholder: 'Название или характер',
            statusAll: 'Все статусы',
            selectPlaceholder: 'Район',
            selectNeedsCity: 'Сначала выберите город',
            selectEmpty: 'В этом городе районов нет',
            empty: 'Районов пока нет.',
            columns: {
                name: 'Район',
                city: 'Город',
                guide: 'Текст',
                status: 'Статус',
            },
            editor: {
                newTitle: 'Новый район',
                fallbackTitle: 'Район #{{id}}',
                created: 'Район создан',
                saved: 'Сохранено',
                deleted: 'Удалено',
                delete: 'Удалить',
                confirmDelete: 'Удалить «{{title}}»?',
                required: 'Нужны название и город.',
                coords: 'Широта и долгота задаются парой.',
                publishNeedsText: 'Для публикации нужен один готовый язык.',
                readyNeedsCopy: 'Готовому языку нужны название и характер, причина или где жить.',
                identity: 'Район',
                title: 'Каноническое имя',
                slug: 'Слаг',
                slugHint: 'Пустое поле соберётся из названия.',
                city: 'Город',
                district: 'Район',
                lat: 'Широта',
                lng: 'Долгота',
                status: 'Статус',
                statusHint: 'Опубликованный район может попасть на страницу города.',
                tabs: { card: 'Карточка', text: 'Текст' },
                copyTitle: 'Текст гида',
                copyHint: 'Какая это часть города. Где жить — абзац, не список отелей.',
                name: 'Название',
                localName: 'Местное имя',
                localNameHint: 'Вторая строка: Раттанакосин, Яоварат, Петроградка.',
                characterLine: 'Подпись на карте',
                characterLineHint: 'Одна фраза. Храмы и первый день, светская богема.',
                portrait: 'Характер',
                portraitHint: 'Каково здесь находиться.',
                why: 'Зачем идти',
                whyHint: 'Зачем сюда приходят и в какое время дня.',
                stay: 'Где жить',
                stayHint: 'Один абзац про то, чтобы остановиться здесь.',
                streets: 'Улицы',
                streetsHint: 'Те, по которым район узнают. Одна строка.',
                knownFor: 'Чем славится',
                knownForHint: 'Одно-два предложения, без цен и расписаний.',
                tags: 'Теги',
                tagsHint: 'Короткие подписи через запятую. Много людей, Храмы.',
                guideName: 'Имя гида',
                guideRole: 'Кто это',
                guideTip: 'Совет гида',
                guideTipHint: 'Одна практическая заметка. Пока можно заглушку.',
                coverUrl: 'Фото района',
                coverUrlHint: 'Кадр, по которому район узнают. Ссылка на файл.',
                coverAuthor: 'Автор фото',
                coverLicense: 'Лицензия',
                coverSourceUrl: 'Страница файла',
                ready: 'Готово для гида',
                readyHint: 'Этот язык можно публиковать.',
            },
        },
        foods: {
            title: 'Еда',
            subtitle: 'Местный ритуал и места, где его едят. Один абзац, без аудио.',
            create: 'Создать',
            searchPlaceholder: 'Название или ритуал',
            statusAll: 'Все статусы',
            empty: 'Ритуалов пока нет.',
            columns: {
                name: 'Ритуал',
                city: 'Город',
                district: 'Район',
                places: 'Места',
                status: 'Статус',
            },
            editor: {
                newTitle: 'Новая еда',
                fallbackTitle: 'Еда #{{id}}',
                created: 'Еда создана',
                saved: 'Сохранено',
                deleted: 'Удалено',
                delete: 'Удалить',
                confirmDelete: 'Удалить «{{title}}»?',
                required: 'Нужны название и город.',
                publishNeedsText: 'Для публикации нужен один готовый язык.',
                readyNeedsCopy: 'Готовому языку нужны название и абзац.',
                identity: 'Ритуал',
                title: 'Каноническое имя',
                slug: 'Слаг',
                slugHint: 'Пустое поле соберётся из названия.',
                city: 'Город',
                districtHint: 'Необязательно. Часть города, к которой относится ритуал.',
                status: 'Статус',
                statusHint: 'Опубликованный ритуал может попасть на страницу города.',
                tabs: { card: 'Карточка', text: 'Текст' },
                copyTitle: 'Текст гида',
                copyHint: 'Что это за ритуал и почему его делают именно здесь.',
                name: 'Название',
                pitch: 'Абзац',
                pitchHint: 'Один абзац. Без меню и цен.',
                ready: 'Готово для гида',
                readyHint: 'Этот язык можно публиковать.',
                places: 'Где это едят',
                placesHint: 'Опубликованные заведения. Заметка — что заказать, на каждом языке.',
                orderNote: 'Что заказать ({{lang}})',
                addPlace: 'Заведение',
                add: 'Добавить',
            },
        },
        establishments: {
            title: 'Заведения',
            subtitle: 'Кафе, бары, дворы и фудкорты для сити-гайдов.',
            create: 'Создать',
            searchPlaceholder: 'Название, команда, район',
            statusAll: 'Все статусы',
            kindAll: 'Все формы',
            offerAll: 'Все форматы',
            ownerAll: 'Все подтверждения',
            reviewAll: 'Все анкеты',
            empty: 'Заведений пока нет.',
            owner: {
                unconfirmed: 'Не подтверждено',
                link_sent: 'Ссылка отправлена',
                confirmed: 'Подтверждено владельцем',
            },
            review: {
                pending: 'На ревью',
                rejected: 'Пакет отклонён',
                approved: 'Опубликовано',
                none: 'Нет пакета',
            },
            columns: {
                name: 'Место',
                city: 'Город',
                kind: 'Форма',
                offers: 'Формат',
                guide: 'Текст',
                status: 'Статус',
                owner: 'Владелец',
                review: 'Анкета',
                visited: 'Заходил',
                edited: 'Правил анкету',
            },
            editor: {
                newTitle: 'Новое заведение',
                fallbackTitle: 'Заведение #{{id}}',
                created: 'Заведение создано',
                saved: 'Сохранено',
                deleted: 'Удалено',
                delete: 'Удалить',
                confirmDelete: 'Удалить «{{title}}»?',
                required: 'Нужны название и город.',
                hoursPair:
                    '{{day}}: укажите и открытие, и закрытие, или оставьте день неизвестным.',
                coords: 'Широту и долготу задают вместе.',
                year: 'Год открытия — от 1800 до 2100.',
                publishNeedsText: 'Сначала сохраните готовый текст хотя бы на одном языке.',
                readyNeedsCopy: 'Для гайда нужны название и текст, зачем сюда идут.',
                tabs: {
                    card: 'Карточка',
                    intake: 'Анкета',
                    text: 'Текст',
                    photos: 'Фото',
                    facts: 'Факты',
                },
                intakeLead:
                    'Те же поля, что в анкете владельца. Текст гайда — на «Текст», снимки — на «Фото».',
                door: 'Дверь',
                doorName: 'Имя на двери',
                doorNameHint: 'Каноническое имя. Название в гайде задаётся на вкладке «Текст».',
                reach: 'Как связаться',
                spend: 'Сколько обычно тратит один',
                spendUnset: 'Не знаем',
                spendUnder: 'До {{amount}} {{currency}}',
                spendOver: 'Больше {{amount}} {{currency}}',
                cuisine: 'Кухня, до двух',
                drink: 'Напитки, до двух',
                room: 'Зал, до двух',
                rules: 'Правила дома',
                pets: 'Собаки',
                age: 'Возраст для алкоголя',
                ageHint: 'Число — возраст, с которого в этой стране можно алкоголь.',
                ageRestricted: '{{age}}+ всю ночь',
                booking: 'Места',
                cash: 'Только наличные',
                unset: 'Нет ответа',
                closedTemporary: 'Временно закрыто',
                hoursNoteOnIntake:
                    'Оговорка к часам для русского текста правится во вкладке «Анкета».',
                identity: 'Место',
                identityHint:
                    'Одна комната или целый двор. Фудкорт — одна карточка, не карточка на каждый киоск.',
                title: 'Каноническое имя',
                slug: 'Слаг',
                slugHint: 'Пустое поле соберётся из названия.',
                city: 'Город',
                district: 'Район',
                kind: 'Форма',
                kindHint: 'Одно место — кафе или бар. Площадка — весь фудкорт или двор.',
                offers: 'Зачем приходят',
                offersHint: 'Можно несколько: кофе днём и бар вечером.',
                operator: 'Кто держит',
                operatorHint: 'Для поиска. В текст гайда не попадает.',
                where: 'Где',
                neighborhood: 'Квартал',
                address: 'Адрес',
                lat: 'Широта',
                lng: 'Долгота',
                hours: 'Часы',
                hoursHint: 'Пустой день — не знаем, не «закрыто». После полуночи — 02:00.',
                copyWeekdays: 'Будни как понедельник',
                closedDay: 'Закрыто',
                opens: 'Открытие',
                closes: 'Закрытие',
                practical: 'Практика',
                contacts: 'Связь',
                contactsHint: 'Анкета уходит в WhatsApp, LINE, Instagram или Facebook.',
                instagram: 'Instagram',
                whatsapp: 'WhatsApp',
                facebook: 'Facebook',
                line: 'LINE',
                phone: 'Телефон',
                website: 'Сайт',
                openedYear: 'Год открытия',
                priceLevel: 'Счёт',
                priceHint: 'Необязательно. Пусто, пока никто не был.',
                status: 'Статус',
                statusHint:
                    'В гайды — карточку можно ставить в сити-гайд. Закрыто оставляет строку, чтобы место больше не рекомендовать.',
                closedNote: 'Почему закрыто',
                copyTitle: 'Текст для гайда',
                copyHint:
                    'Это то, что напечатает сити-гайд. Коротко: зачем сюда идёт своя публика и как найти дверь.',
                displayName: 'Название',
                tags: 'Теги',
                tagsHint:
                    'Чипы на карточке. Счёт задаётся отдельно. Русские чипы пересобираются из анкеты.',
                specialties: 'Теги блюд',
                specialtiesHint:
                    'Одна тарелка, ради которой идут. Вторая — только если комната честно про обе. На карточке гость видит свой язык.',
                pitch: 'Зачем идут',
                pitchHint: 'Одно-два предложения.',
                findHint: 'Как найти',
                findHintHelp: 'Этаж, двор, вход.',
                hoursNote: 'Оговорка к часам',
                hoursNoteHint: 'Кухня раньше, дверь переехала, сверить перед визитом.',
                ready: 'Готово для гайда',
                readyHint: 'Нужны название и текст, зачем сюда идут.',
                intakeLink: 'Скопировать ссылку',
                intakeCopied: 'Короткая ссылка скопирована.',
                sendWhatsapp: 'WhatsApp',
                sendLine: 'LINE',
                sendInstagram: 'Instagram',
                ownerBox: 'Владельцу',
                packTitle: 'Пакет',
                packSame: 'Факты совпадают с карточкой.',
                packChips: 'Публикация обновит чипы.',
                photoCredit: 'Автор фото',
                coordsLabel: 'Координаты',
                openMap: 'Открыть на карте',
                intakeChatOpened: 'Чат открыт в новой вкладке. Текст со ссылкой уже в сообщении.',
                intakeInstagramPaste: 'Текст со ссылкой скопирован. Вставьте его в чат.',
                intakeNoChannel: 'Некуда отправить: нет WhatsApp, Facebook, Instagram или LINE.',
                intakeVisited: 'Заходил',
                intakeEdited: 'Правил',
                intakeLinkSent: 'Ссылка',
                intakeApprove: 'Опубликовать пакет',
                intakeReject: 'Отклонить',
                intakeApproved: 'Пакет опубликован. Текст гайда не менялся.',
                intakeRejectedDone: 'Пакет отклонён. На карточке осталось прежнее.',
                confirmApprove: 'Опубликовать пакет владельца? Текст гайда не изменится.',
                confirmReject: 'Отклонить пакет? На карточке останется то, что есть сейчас.',
                photos: 'Фото',
                photosHint: 'Звезда отмечает обложку, которую возьмёт гайд.',
            },
        },
        authors: {
            title: 'Авторы контента',
            create: 'Создать',
            columns: {
                name: 'Имя',
                commission: 'Комиссия',
                quests: 'Квесты',
                inReview: 'На проверке',
                email: 'Email',
                status: 'Статус',
            },
            verified: 'Подтверждён',
            notVerified: 'Не подтверждён',
            empty: 'Авторы не найдены.',
        },
        activities: {
            title: 'Туры GetYourGuide',
            add: 'Добавить из GetYourGuide',
            addTitle: 'Привязать тур GetYourGuide',
            filterCity: 'Фильтр по городу',
            pickCityFirst: 'Сначала выберите город',
            searchPlaceholder: 'Пешеходная экскурсия, круиз…',
            searchHint: 'Найдите туры GetYourGuide рядом с городом и привяжите их.',
            attach: 'Привязать',
            attached: 'Тур привязан',
            alreadyAttached: 'Уже привязан',
            publish: 'На сайте',
            featured: 'Избранное',
            notConfigured:
                'Partner API GetYourGuide не настроен. Задайте GETYOURGUIDE_ACCESS_TOKEN на API.',
            empty: 'Пока нет активностей. Выберите город и добавьте туры из GetYourGuide.',
            status: {
                draft: 'Черновик',
                published: 'Опубликовано',
            },
            columns: {
                tour: 'Тур',
                price: 'От',
                featured: 'Избранное',
            },
        },
        venues: {
            title: 'Партнёры-площадки',
            create: 'Создать',
            parseByCity: 'Парсинг площадок по городу',
            markInviteSent: 'Отметить как приглашённых ({{count}})',
            blockSelected: 'Заблокировать выбранных',
            rejectSelected: 'Отклонить выбранных',
            columns: {
                venue: 'Площадка',
                email: 'Email',
                city: 'Город',
                promocode: 'Промокод',
                commission: 'Комиссия',
                status: 'Статус',
            },
            empty: 'Партнёры-площадки не найдены.',
            selectVenuesFirst: 'Сначала выберите площадки',
            promptCityId: 'ID города для парсинга площадок:',
            invalidCityId: 'Некорректный ID города',
            confirmParse:
                'Спарсить туристическое размещение (отели, хостелы и т.д.) для города #{{id}} из Google Places?\n\nСоздаются только новые площадки. Существующие закрытые места будут помечены как закрытые.',
            confirmBulkStatus: 'Установить статус «{{status}}» для {{count}} площадок?',
            parsedTitle: 'Обработан {{city}}',
            parsedMessage:
                'Найдено {{found}} · создано {{created}} · закрыто {{closed}} · пропущено {{skipped}}',
            bulkUpdated: 'Обновлено {{count}} площадок',
        },
        orders: {
            title: 'Поставка буклетов',
            columns: {
                date: 'Дата',
                venue: 'Площадка',
                qty: 'Кол-во',
                status: 'Статус',
            },
            empty: 'Заказов материалов нет.',
        },
        purchases: {
            title: 'Продажи контента',
            detailTitle: 'Покупка #{{id}}',
            detailFallback: 'Покупка',
            empty: 'Нет покупок по выбранным фильтрам.',
            permanent: 'Бессрочно',
            noEntitlement: 'Связанный entitlement не найден.',
            noAttribution: 'Партнёрской атрибуции на этой покупке нет.',
            noConsent: 'Лога согласия на чекауте нет (обычно для IAP).',
            tabs: {
                route: 'Маршруты',
                quest: 'Квесты',
                city: 'Города',
                pass: 'Пассы',
            },
            status: {
                paid: 'Оплачено',
                refunded: 'Возврат',
            },
            entitlementStatus: {
                active: 'Активен',
                expired: 'Истёк',
                revoked: 'Отозван',
            },
            filters: {
                search: 'Покупатель',
                searchPlaceholder: 'Email или имя…',
                city: 'Город',
                provider: 'Провайдер',
                status: 'Оплата',
                allProviders: 'Все провайдеры',
                allStatuses: 'Все',
            },
            columns: {
                date: 'Дата',
                buyer: 'Покупатель',
                product: 'Продукт',
                amount: 'Сумма',
                provider: 'Провайдер',
                partner: 'Партнёр',
                status: 'Статус',
            },
            sections: {
                product: 'Продукт',
                buyer: 'Покупатель',
                payment: 'Оплата',
                entitlement: 'Доступ',
                attribution: 'Атрибуция партнёру',
                consent: 'Согласие на чекауте',
            },
            fields: {
                scope: 'Тип',
                scopeId: 'ID объекта',
                city: 'Город',
                email: 'Email',
                name: 'Имя',
                playerId: 'ID игрока',
                playerSince: 'Регистрация',
                lastLogin: 'Последний вход',
                emailVerified: 'Email подтверждён',
                playerPurchases: 'Покупок у игрока',
                amount: 'Сумма',
                tax: 'Налог',
                provider: 'Провайдер',
                externalId: 'Внешний ID',
                refundedAt: 'Возврат',
                createdAt: 'Дата покупки',
                status: 'Статус',
                entitlementId: 'ID доступа',
                source: 'Источник',
                expiresAt: 'Истекает',
                revokedAt: 'Отозван',
                storeTxn: 'Транзакция стора',
                venue: 'Площадка',
                venueEmail: 'Email площадки',
                promocode: 'Промокод',
                claimCode: 'Код клейма',
                discount: 'Скидка гостю',
                claimAttributed: 'Покупок по клейму',
                commission: 'Комиссия',
                commissionStatus: 'Статус комиссии',
                consentEmail: 'Email согласия',
                docsVersion: 'Версия документов',
                locale: 'Локаль',
                consentAt: 'Дата согласия',
            },
        },
        reviews: {
            title: 'Отзывы игроков',
            create: 'Добавить отзыв',
            detailTitle: 'Отзыв',
            empty: 'Нет отзывов по выбранным фильтрам.',
            confirmDelete: 'Удалить этот отзыв навсегда?',
            createValidation: 'Нужны город, объект, автор и текст (от 20 символов).',
            localesHeading: 'Переводы',
            noLocales: 'Переводов ещё нет — нажмите «Перевести на все языки».',
            filters: {
                allStatuses: 'Все статусы',
                allSubjects: 'Все типы',
            },
            columns: {
                author: 'Автор',
                subject: 'Объект',
                rating: 'Оценка',
                body: 'Текст',
                locales: 'Языки',
                status: 'Статус',
            },
            actions: {
                approve: 'Одобрить',
                reject: 'Отклонить',
                translateAll: 'Перевести на все языки',
                delete: 'Удалить',
            },
            fields: {
                subjectType: 'Тип',
                subject: 'Квест / маршрут',
                subjectPlaceholder: 'Выберите…',
                pickCityFirst: 'Сначала выберите город',
                authorName: 'Имя автора',
                authorAvatar: 'Фото автора',
                sourceLanguage: 'Язык оригинала',
                rating: 'Оценка',
                body: 'Текст отзыва',
                bodyHint: 'Минимум 20 символов. Пишите на языке оригинала.',
                photos: 'Фото (до 3)',
                publish: 'Публикация',
                publishYes: 'Сразу опубликовать',
                publishNo: 'Оставить на модерации',
            },
            toasts: {
                approved: 'Отзыв одобрен.',
                rejected: 'Отзыв отклонён.',
                translated: 'Переведено на {{count}} языков.',
                deleted: 'Отзыв удалён.',
                created: 'Отзыв создан.',
            },
        },
        translations: {
            title: 'Переводы',
            syncCdn: 'Синхронизировать CDN',
            generateJson: 'Сгенерировать JSON',
            namespace: 'Пространство имён',
            createKey: 'Создать ключ',
            searchPlaceholder: 'Поиск по ключу или тексту',
            allNamespaces: 'Все пространства имён',
            columns: {
                key: 'Ключ',
                namespace: 'Пространство имён',
                context: 'Контекст',
                locales: 'Локали',
            },
            empty: 'Переводы не найдены.',
            noContext: 'Нет контекста',
            saveLocale: 'Сохранить локаль',
            localeSaved: 'Локаль сохранена.',
            localeTextRequired: 'Текст локали обязателен.',
            jsonGenerated: 'JSON сгенерирован в CDN / на диск.',
            syncedFromCdn: 'Синхронизировано с CDN.',
            syncedFromCdnStats: 'Синхронизировано с CDN ({{stats}}).',
            namespaceTitleRequired: 'Название пространства имён обязательно.',
            namespaceCreated: 'Пространство имён создано.',
            keyRequiredFields: 'Ключ, исходный текст и пространство имён обязательны.',
            translationKeyCreated: 'Ключ перевода создан.',
            createKeyModal: {
                title: 'Создать ключ перевода',
                namespace: 'Пространство имён',
                key: 'Ключ',
                sourceText: 'Исходный текст',
                context: 'Контекст',
                create: 'Создать',
            },
            createNamespaceModal: {
                title: 'Создать пространство имён',
                titleField: 'Название',
                create: 'Создать',
            },
        },
        users: {
            title: 'Учётные записи',
            createAdmin: 'Создать админа',
            noAccess: 'У вас нет доступа к этому разделу.',
            tabs: {
                admins: 'Админы',
                activity: 'Активность',
                statistics: 'Статистика',
            },
            columns: {
                name: 'Имя',
                email: 'Email',
                access: 'Доступ',
            },
            fullAccess: 'Полный доступ',
            fieldAdmin: 'Админ в приложении',
            noRights: 'Нет прав',
            assignedRoutesCount: '{{count}} маршрутов',
            empty: 'Учётных записей админов пока нет.',
            edit: 'Редактировать',
            delete: 'Удалить',
            modal: {
                createTitle: 'Создать админа',
                editTitle: 'Редактировать админа',
                account: 'Учётная запись',
                name: 'Имя',
                email: 'Email',
                password: 'Пароль',
                newPassword: 'Новый пароль',
                passwordHint: 'Оставьте пустым, чтобы сохранить текущий пароль.',
                fullAccessSwitch: 'Полный доступ (все разделы)',
                fieldAdminSwitch: 'Админ в приложении',
                fieldAdminHint:
                    'Этот email в приложении может ставить служебные точки и писать технические заметки.',
                fieldAdminFromFullAccess:
                    'Полный доступ уже включает это. Отдельная галочка нужна только админу без полного доступа.',
                permissions: 'Права доступа',
                permissionsHint: 'Выдайте доступ по разделам и возможностям.',
                assignedRoutes: 'Маршруты, которые можно открыть',
                assignedRoutesHint:
                    'Откроются только эти маршруты. Можно править тексты точек; структура, озвучка и метаданные закрыты.',
                routeSearch: 'Найти маршрут',
                noRoutesSelected: 'Маршруты не выбраны — список будет пустым.',
                routesLoading: 'Загрузка маршрутов…',
                cancel: 'Отмена',
                create: 'Создать',
                save: 'Сохранить',
            },
            nameEmailRequired: 'Имя и email обязательны.',
            passwordRequired: 'Пароль обязателен.',
            adminCreated: 'Админ создан.',
            adminUpdated: 'Админ обновлён.',
            cannotDeleteSelf: 'Вы не можете удалить собственную учётную запись.',
            confirmDelete: 'Удалить админа {{email}}?',
            adminDeleted: 'Админ удалён.',
            sectionDescriptions: {
                dashboard: 'Обзор и сводка по пайплайну городов.',
                cities: 'Каталог городов и мета локалей.',
                quests: 'Городские квесты — мета, конструктор, локали.',
                routes: 'Готовые пешеходные маршруты. «Текст» — только тексты точек на выбранных маршрутах.',
                people: 'Исторические личности, связанные с городами.',
                attractions: 'Пул мест / достопримечательностей.',
                establishments: 'Кафе, бары и площадки, которые можно поставить в сити-гайд.',
                authors: 'Учётные записи авторов портала.',
                venues: 'Учётные записи партнёров-площадок портала.',
                activities: 'Туры GetYourGuide по городам.',
                orders: 'Заказы материалов от партнёров-площадок.',
                purchases: 'Покупки контента — маршруты, квесты, пакеты городов и пассы.',
                reviews: 'Отзывы игроков на квесты и маршруты.',
                translations: 'Ключи переводов и недостающие строки.',
                qa: 'Квиз качества текстовых правок модераторов.',
                users: 'Создание и управление учётными записями админов и правами.',
            },
            activity: {
                selectAdmin: 'Выберите админа',
                selectAdminHint: 'Выберите админа, чтобы увидеть почасовую активность за день.',
                date: 'Дата',
                empty: 'За этот день активности нет.',
                emptyRequests: 'За этот час запросов нет.',
                requests: 'Запросы',
                requestsTitle: '{{email}} · {{date}} · {{hour}}',
                columns: {
                    hour: 'Час',
                    requests: 'Запросы',
                    firstRequest: 'Первый запрос',
                    lastRequest: 'Последний запрос',
                    time: 'Время',
                    method: 'Метод',
                    path: 'Путь',
                },
            },
            statistics: {
                admin: 'Админ',
                allAdmins: 'Все админы',
                startDate: 'Дата начала',
                endDate: 'Дата окончания',
                empty: 'За этот период статистики нет.',
                columns: {
                    date: 'Дата',
                    workingHours: 'Рабочие часы',
                    workingMinutes: 'Рабочие минуты',
                    photosAdded: 'Фото добавлено',
                    textsChanged: 'Тексты изменены',
                    statusesChanged: 'Статусы изменены',
                    totalRequests: 'Всего запросов',
                },
            },
        },
        qa: {
            title: 'Проверка правок',
            remaining: '{{count}} в очереди',
            empty: 'Нет текстовых правок на проверке.',
            emptyValue: '—',
            was: 'Было',
            became: 'Стало',
            field: 'Поле',
            aiEditor: 'ИИ',
            legendDeleted: 'удалилось',
            legendAdded: 'добавилось',
            legendChanged: 'слово изменилось',
            ok: 'Ок',
            bad: 'Плохо',
            filters: {
                admin: 'Кто правил',
                allAdmins: 'Все админы',
                entityType: 'Тип сущности',
                allTypes: 'Все типы',
            },
            entityTypes: {
                attraction: 'Достопримечательность',
                person: 'Персона',
                route: 'Маршрут',
                quest: 'Квест',
            },
        },
        wiki: {
            title: 'Wiki для модераторов',
            subtitle: 'Инструкции по вычитке и дозаполнению квестов, точек и статусам контента.',
            back: 'Все гайды',
            groups: {
                moderation: 'Модерация квестов',
                writing: 'Тексты и редактура',
                ops: 'Операции',
            },
            articles: {
                questModeration: {
                    title: 'Гайд модератора квестов',
                    summary: 'Дозаполнение, вычитка и верификация от need_review до ready.',
                },
                questWriting: {
                    title: 'Гайд по написанию квестов',
                    summary: 'Структура городских квестов, стопов и драматургии.',
                },
                attractionWriting: {
                    title: 'Гайд по текстам точек',
                    summary: 'Правила голоса для гайд-толков достопримечательностей.',
                },
                routeWriting: {
                    title: 'Гайд по аудиомаршрутам',
                    summary:
                        'Обзорный и тематический контракты, одна история на точку, голос, факты и геометрия.',
                },
                spbAttractionEditing: {
                    title: 'Бриф: редактура точек СПб',
                    summary: 'Как довести RU гайд-толки до эталона 10/10.',
                },
                questTemplates: {
                    title: 'Масштабируемые шаблоны квестов',
                    summary: 'Город-независимые сюжеты для проверки и дозаполнения.',
                },
                contentOps: {
                    title: 'Операции с контентом',
                    summary: 'Статусы модерации, пайплайны и правила по персонам.',
                },
                arAnchorPhoto: {
                    title: 'Бриф: якорные фото AR',
                    summary: 'Как снимать эталонные фото для image-tracking / ar_hunt.',
                },
            },
        },
    },
    editors: {
        establishmentFacts: {
            title: 'Банк фактов заведения',
            description:
                'Текст «зачем сюда идти» пишется только из фактов с пометкой «Берём» или «Обязательно». Для текста нужны четыре хода: крючок, интеллект, ламповость, совет.',
            beat: {
                hook: 'Крючок',
                wit: 'Интеллект',
                warmth: 'Ламповость',
                tip: 'Совет',
                find: 'Как найти',
                background: 'Фон',
            },
            beatPlaceholder: 'Ход в тексте',
            sources: 'источников {{count}}',
            counter: 'показано {{shown}} из {{total}}, выбрано {{chosen}}',
            copyPack: 'Скопировать пакет для текста',
            packIntro:
                'Факты, одобренные редактором. Пиши pitch по docs/venue-pitch-guide.md только из них. [!] — обязательно использовать.',
            packCopied: 'Пакет фактов скопирован',
            remove: 'Удалить',
            removeConfirm: 'Удалить факт?',
            emptyBank: 'Фактов пока нет. Их собирает агент через MCP или редактор вручную.',
        },
        attractionFacts: {
            title: 'Банк фактов',
            description:
                'Исследователь собирает всё, что нашёл, ИИ-редактор проверяет и ранжирует. Вы решаете, что идёт в историю: «Берём» и «Обязательно» попадают в бриф.',
            startResearch: 'Запустить исследование',
            addFact: 'Добавить факт',
            noRuns: 'Исследование ещё не запускалось.',
            runLine:
                'Запуск #{{id}} ({{kind}}): {{status}}. Найдено {{found}}, новых {{created}}, дублей {{duplicates}}, цитата подтверждена у {{grounded}}, оценено {{scored}}',
            usageLine:
                'Расход: вход {{input}} (кэш {{cached}}), выход {{output}} (рассуждения {{reasoning}}), веб-поисков {{searches}}, вызовов {{calls}}',
            runKind: {
                research: 'исследование',
                deepen: 'углубление',
                dedupe: 'склейка дублей',
                score: 'черновая оценка',
            },
            depth: {
                auto: 'Глубина: авто',
                economy: 'Экономно (до $4)',
                standard: 'Обычная точка',
                deep: 'Флагман: глубоко',
            },
            deepenChosen: 'Углубить выбранные',
            deepenOne: 'Углубить',
            deepened: 'углублён',
            dedupe: 'Склеить дубли',
            draftScore: 'Черновая оценка',
            draftBadge: 'черновая оценка',
            duplicateOf: 'дубль #{{id}}',
            runStarted: 'Запуск #{{id}} начат',
            showLog: 'Показать журнал',
            hideLog: 'Скрыть журнал',
            loading: 'Загружаем факты…',
            empty: 'Фактов под этот фильтр нет.',
            kindPlaceholder: 'Тип факта',
            searchPlaceholder: 'Поиск по тексту',
            rolePlaceholder: 'Роль в истории',
            notePlaceholder: 'Заметка редактора',
            aiPrefix: 'ИИ:',
            observable: 'видно на месте',
            volatile: 'меняется',
            whereToSee: 'Где увидеть',
            sources: 'источников {{count}}, подтверждено {{grounded}}',
            usedIn: 'использован: {{list}}',
            groundedYes: 'цитата найдена',
            groundedNo: 'цитата не найдена',
            groundedUnknown: 'не проверено',
            newClaim: 'Факт (одно утверждение по-русски)',
            newDetail: 'Контекст',
            newUrl: 'Ссылка на источник',
            newQuote: 'Цитата из источника',
            view: {
                all: 'Все',
                passed: 'ИИ одобрил',
                pending: 'Не решено',
                chosen: 'Берём',
                rejected: 'Отказ',
                duplicates: 'Дубли',
            },
            decision: { pending: '—', take: 'Берём', must: 'Обязательно', reject: 'Отказ' },
            role: {
                spine: 'Стержень',
                bead: 'Бусина рассказа',
                hook: 'Зацепка',
                primer: 'Ликбез',
                card: 'Карточка',
                fun_fact: 'Забавный факт',
                look_for: 'Что найти глазами',
                background: 'Фон',
            },
            truth: {
                unchecked: 'не проверен',
                confirmed: 'подтверждён',
                legend: 'легенда',
                disputed: 'спорный',
                unverified: 'слабый источник',
                false: 'ложный',
            },
            verdict: {
                passed: 'прошёл',
                needs_check: 'нужна проверка',
                failed: 'не прошёл',
                duplicate: 'дубль',
            },
            sensitivity: {
                none: '',
                tragedy: 'трагедия',
                memorial: 'мемориал',
                religion: 'религия',
                politics: 'политика',
            },
            score: {
                surprise: 'удивление',
                retellability: 'пересказ',
                specificity: 'конкретика',
                visual: 'визуал',
                humor: 'юмор',
                placeRelevance: 'про место',
            },
            kind: {
                origin: 'Зачем и откуда',
                anecdote: 'Анекдот',
                person: 'Человек',
                event: 'Событие',
                architecture: 'Архитектура',
                visible_detail: 'Видимая деталь',
                legend: 'Легенда',
                record: 'Рекорд',
                pop_culture: 'Поп-культура',
                everyday: 'Быт',
                scale: 'Масштаб',
                controversy: 'Скандал',
                tragedy: 'Трагедия',
                today: 'Сегодня',
                other: 'Другое',
            },
        },
        attractionBrief: {
            title: 'Бриф истории',
            description:
                'План рассказа поверх отобранных фактов. Текст пишется только по утверждённому брифу.',
            none: 'брифа нет',
            status: { draft: 'черновик', approved: 'утверждён' },
            author: { ai: 'составил ИИ', editor: 'правил редактор' },
            promise: 'Обещание точки',
            promiseHint: 'Одна строка: зачем здесь останавливаться.',
            spine: 'Стержень',
            spineHint: 'Нитка, на которую нанизаны все бусины рассказа.',
            hookIdea: 'Зацепка для начала',
            beads: 'Бусины рассказа',
            beadsHint:
                'Факты для guideTalk в порядке рассказа. В списке только «Берём» и «Обязательно».',
            cards: 'Карточки «Коротко»',
            cardsHint: '2–3 карточки одной истории, у каждой — идея заголовка-панчлайна.',
            cardTitle: 'Идея заголовка',
            cardFacts: 'Факты карточки',
            addCard: 'Добавить карточку',
            extras: 'Забавный факт и что найти глазами',
            funFact: 'Забавный факт',
            lookFor: 'Что найти глазами',
            notes: 'Заметки к тексту',
            saveDraft: 'Сохранить черновик',
            approve: 'Утвердить бриф',
            saved: 'Бриф сохранён',
        },
        staffNotes: {
            title: 'Технические заметки',
            description: 'Написаны в приложении. Посетителям не показываются.',
            empty: 'Заметок пока нет.',
        },
        attraction: {
            newTitle: 'Новая достопримечательность',
            fallbackTitle: 'Достопримечательность #{{id}}',
            tabs: {
                details: 'Детали',
                locales: 'Локали',
                media: 'Медиа',
                artifacts: 'Артефакты',
                facts: 'Факты',
                brief: 'Бриф',
                review: 'Модерация',
            },
            identity: {
                title: 'Идентичность',
                titleLabel: 'Название',
                address: 'Адрес',
                country: 'Страна',
                category: 'Категория',
                fame: 'Известность',
                lat: 'Широта',
                lng: 'Долгота',
                knownForEn: 'Известен(на) чем (EN)',
                knownForHint:
                    'Заполняет английскую локаль; отредактируйте позже на вкладке Копирайт.',
                descriptionEn: 'Описание (EN)',
                descriptionHint:
                    'Заполняет английскую локаль; отредактируйте позже на вкладке Копирайт.',
            },
            copy: {
                title: 'Копирайт',
                localeTitle: 'Название локали',
                knownFor: 'Известен(на) чем',
                description: 'Описание',
            },
            guidePackage: {
                title: 'Пакет гида',
                hook: 'Затравка',
                guideTalk: 'Рассказ гида',
                cardN: 'Карточка {{n}}',
                cardEmoji: 'Эмодзи',
                cardTitle: 'Название карточки',
                cardBody: 'Текст карточки',
                addCard: 'Добавить карточку',
                removeCard: 'Удалить',
                funFact: 'Интересный факт',
                funFactEmoji: 'Эмодзи',
                funFactTitle: 'Заголовок факта',
                funFactKind: 'Тип',
                lookFor: 'Что искать (через запятую)',
                guideAudio: 'Аудио гида',
                generateTts: 'Сгенерировать озвучку',
                localeStatus: 'Статус локали',
            },
            visit: {
                title: 'Визит',
                hint: 'Показывается на карточке места и не попадает в аудио.',
                durationMin: 'Визит от (мин)',
                durationMax: 'Визит до (мин)',
                isFree: 'Вход свободный',
                ticketRequired: 'Нужен билет',
                bookingRequired: 'Нужна запись',
                familyFriendly: 'Можно с детьми',
                rainFriendly: 'Можно в дождь',
                nightFriendly: 'Можно вечером',
                hoursNote: 'Заметка о часах',
                hoursNoteHint: 'Строка про часы работы. Без цен.',
                priceNote: 'Цена',
                priceNoteHint: 'Текущая цена входа, одной строкой. В аудио не попадает.',
                visitNote: 'Как посещать',
                visitNoteHint:
                    'Дресс-код, обувь, съёмка, часы молитв, какой вход. В аудио не попадает.',
            },
            layers: {
                tier: 'Цель места',
                tierHint: 'Маршрут и полный рассказ идут до аудио, лёгкая карточка — без аудио',
                lightApproved: 'Лёгкая карточка одобрена',
                triage: 'Триаж: {{verdict}}, интерес {{interest}}/10',
                scout: 'Разведка: {{score}}/10, {{verdict}}. {{hooks}}',
            },
            attributes: {
                title: 'Атрибуты',
                tags: 'Интересы',
                tagsHint:
                    'О чём место. «С детьми», «бесплатно», «в дождь» и «вечером» — это флаги визита ниже.',
                audioPotential: 'Аудиоистория',
                audioHint:
                    'Насколько место тянет на самостоятельный рассказ. Туристическая ценность остаётся в must-see. Пусто — берётся оценка разведки.',
                audioFromScout:
                    'Разведка предлагает {{value}}. Сохранённый выбор становится редакционным.',
                mustSeeScore: 'Must-see (1–10)',
                wowScore: 'Вау-эффект (1–10)',
                touristCrowdScore: 'Туристическая толпа (1–10)',
                localExperienceScore: 'Местный опыт (1–10)',
                routeRole: 'Роль в маршруте',
                indoorOutdoor: 'Помещение / улица',
                wikidataId: 'ID в Wikidata',
                isFreePreview: 'Бесплатное превью (доступно без пакета города)',
            },
            actions: {
                title: 'AI и обслуживание',
                regenerate: 'Перегенерировать контент',
                regenerateConfirm:
                    'Перегенерировать контент {{lang}} с помощью AI?\n\nТекущий текст локали будет перезаписан.',
                regenerated: 'Контент локали перегенерирован.',
                ttsDone: 'Аудио гида сгенерировано.',
                deepen: 'Углубить исследование',
                deepenDone: 'Исследование завершено, заполнено полей: {{count}}.',
                generateCover: 'Сгенерировать обложку',
                coverDone: 'Обложка сгенерирована.',
                archive: 'В архив',
                unarchive: 'Из архива',
                archiveConfirm:
                    'Отправить достопримечательность #{{id}} в архив?\n\nОна будет скрыта от игроков; можно вернуть позже.',
                archived: 'Достопримечательность отправлена в архив.',
                unarchived: 'Достопримечательность возвращена из архива.',
            },
            photos: {
                title: 'Фото',
                description:
                    'Отметьте звёздочкой фото, чтобы сделать его обложкой (переместится на первое место).',
                gallery: 'Галерея',
            },
            artifactsPanel: {
                title: 'Артефакты внутри этого места',
                sectionDescription:
                    'Иконки, рукописи, таблички, экспонаты — не отдельные точки на карте. Игроки приходят сюда, а затем ищут объект.',
                artifactN: 'Артефакт {{n}}',
                remove: 'Удалить',
                kind: 'Тип',
                personId: 'ID персоны (необязательно)',
                title2: 'Название',
                findHint: 'Подсказка для поиска (комната / этаж / где искать)',
                knownFor: 'Известен(на) чем',
                description: 'Описание',
                wikidataId: 'ID в Wikidata',
                empty: 'Артефактов пока нет. Добавьте объекты, которые игроки должны найти внутри этого места.',
                addArtifact: 'Добавить артефакт',
            },
            moderation: {
                title: 'Модерация',
                rejectionReason: 'Причина отклонения',
                reject: 'Отклонить',
                approve: 'Одобрить',
            },
            saveMarkReviewed: 'Сохранить и отметить проверенным',
            savePhotos: 'Сохранить фото',
            saveArtifacts: 'Сохранить артефакты',
            saveLocale: 'Сохранить локаль',
            titleCategoryFameRequired: 'Название, категория и известность обязательны.',
            cityRequired: 'Город обязателен.',
            countryRequired: 'Страна обязательна.',
            created: 'Достопримечательность создана.',
            saved: 'Достопримечательность сохранена.',
            localeSaved: 'Локаль сохранена.',
            photosSaved: 'Фото сохранены.',
            artifactTitleRequired: 'У каждого артефакта должно быть название.',
            artifactsSaved: 'Артефакты сохранены.',
            deleteConfirm:
                'Удалить достопримечательность #{{id}}?\n\nЭто действие нельзя отменить.',
            deleted: 'Достопримечательность удалена.',
            approved: 'Достопримечательность одобрена.',
            rejected: 'Достопримечательность отклонена.',
        },
        person: {
            newTitle: 'Новая персона',
            fallbackTitle: 'Персона #{{id}}',
            tabs: {
                details: 'Детали',
                media: 'Фото',
                locales: 'Локали',
                review: 'Модерация',
            },
            identity: {
                title: 'Идентичность',
                name: 'Имя',
                primaryCity: 'Основной город',
                domains: 'Сферы',
                fame: 'Известность',
                recognition: 'Признание',
                recognitionHint:
                    'Мировая = всемирно известное имя; Локальная = нужна история города',
            },
            photos: {
                title: 'Фото',
                description: 'Отметьте звёздочкой фото, чтобы сделать его обложкой.',
                gallery: 'Галерея',
            },
            copy: {
                title: 'Копирайт',
                localeName: 'Имя в локали',
                knownFor: 'Известен(на) чем',
                description: 'Описание',
            },
            facts: {
                title: 'Факты',
                hint: 'Короткие карточки биографии / истории / цитаты для этого языка.',
                addFact: 'Добавить факт',
                kind: 'Тип',
                factTitle: 'Название',
                remove: 'Удалить',
                localeStatus: 'Статус локали',
            },
            moderation: {
                title: 'Модерация',
                reviewStatus: 'Статус модерации',
                rejectionReason: 'Причина отклонения',
                reject: 'Отклонить',
                approve: 'Одобрить',
            },
            saveMarkReviewed: 'Сохранить и отметить проверенным',
            savePhotos: 'Сохранить фото',
            saveLocale: 'Сохранить локаль',
            nameRequired: 'Имя обязательно.',
            domainRequired: 'Выберите хотя бы одну сферу.',
            fameRequired: 'Известность обязательна.',
            created: 'Персона создана.',
            saved: 'Персона сохранена.',
            photosSaved: 'Фото сохранены.',
            localeSaved: 'Локаль сохранена.',
            deleteConfirm: 'Удалить персону #{{id}}? Это действие нельзя отменить.',
            deleted: 'Персона удалена.',
            approved: 'Персона одобрена.',
            rejected: 'Персона отклонена.',
            discardLocaleConfirm: 'Отменить несохранённые изменения в локали?',
        },
        route: {
            newTitle: 'Новый готовый маршрут',
            fallbackTitle: 'Маршрут #{{id}}',
            tabs: {
                meta: 'Мета',
                locales: 'Локали',
                constructor: 'Конструктор',
            },
            cover: {
                title: 'Обложка',
                description: 'Показывается в каталоге игрока и заголовке маршрута.',
            },
            placement: {
                title: 'Размещение',
                city: 'Город',
                status: 'Статус',
                guideType: 'Тип гида',
                guideTypeHint: 'Бейдж на карточке маршрута в приложении и на сайте.',
                mobility: 'Как добираться',
                mobilityHint: 'Пеший маршрут остаётся в городе. Транспорт — выезд на день.',
                mobilityWalk: 'Пешком',
                mobilityTransit: 'Выезд на транспорте',
            },
            author: {
                title: 'Автор',
                description: 'Имя и аватар копируются в маршрут для указания авторства для игрока.',
                attribution: 'Автор: {{name}}',
            },
            walkingStats: {
                title: 'Параметры прогулки',
                description:
                    'Заполняются автоматически по маршруту, если пусто; можно переопределить.',
                from: 'От (мин)',
                to: 'До (мин)',
                distance: 'Расстояние (км)',
            },
            catalogCopy: {
                title: 'Текст для каталога',
                description: 'Языки текста маршрута зависят от выбранной страны города.',
                titleField: 'Название ({{lang}})',
                teaser: 'Тизер ({{lang}})',
                description2: 'Описание ({{lang}})',
                transitNote: 'Как добраться ({{lang}})',
                transitNoteHint:
                    'Дорога туда и обратно. Показывается, когда маршрут — выезд на день.',
            },
            constructorTab: {
                selectCityHint: 'Выберите город на вкладке Мета, чтобы загрузить пул точек карты.',
                searchPlaceholder: 'Поиск по карте…',
                found: 'найдено: {{count}}',
                none: 'ничего',
                placesStopsCount: 'мест: {{places}} · точек маршрута: {{stops}}',
                addWaypoint: 'Добавить путевую точку',
                textOnlyHint: 'Нажмите точку, чтобы править её текст.',
                clickForWaypoint: 'Кликните на карте для путевой точки…',
                stopsTitle: 'Точки маршрута',
                stopsDescription: 'Перетащите для изменения порядка',
                noStops: 'Точек пока нет — добавьте достопримечательности с карты.',
                waypoint: 'Путевая точка',
                stop: 'Точка',
                routeRole: 'Роль в этом маршруте',
                routeRoleHint:
                    'Пусто — рекомендованная роль места. Путевая точка остаётся немой геометрией.',
                alternateStart: 'Альтернативный старт',
                alternateStartHint:
                    'Маршрут можно начать отсюда и не проходить предыдущие точки. Первая точка и так старт.',
                alternateStartBadge: 'ещё старт',
                override: 'переопределено',
                dragToMove: 'Потяните, чтобы переместить',
                placeSectionTitle: 'Место · {{n}}',
                place: 'Место',
                waypointDescription:
                    'Путевая точка — перетащите маркер на карте, чтобы переместить её.',
                selectedAttractionDescription: 'Выбранная достопримечательность на карте.',
                addToRoute: 'Добавить в маршрут',
                noWaypointTexts: 'Путевая точка — без текстов.',
                textsTitle: 'Тексты',
                textsDescriptionOverride:
                    'Переопределения маршрута против исходного текста достопримечательности.',
                textsDescriptionSource: 'Исходный текст достопримечательности.',
                noTextsInLang: 'Нет текстов на {{lang}}.',
                hook: 'Затравка',
                guideTalk: 'Рассказ гида',
                audioSection: 'Озвучка',
                guideAudio: 'Аудио рассказа гида',
                audioHint: 'Длительность: {{guide}}.',
                routeTab: 'Маршрут',
                attractionTab: 'Точка',
                noAttractionTexts: 'Нет текстов точки на {{lang}}.',
                selectStopOrPoint: 'Выберите точку маршрута или объект на карте.',
            },
            saveRoute: 'Сохранить маршрут',
            cityRequired: 'Город обязателен',
            titleRequiredIn: 'Название на {{lang}} обязательно',
            publishWithWarnings: 'Опубликовать с предупреждениями?\n\n{{warnings}}',
            publishWarningCount: 'Предупреждений при публикации: {{count}}',
            noCoordinates: '{{title}}: нет координат',
            routeCreated: 'Маршрут создан',
            routeSaved: 'Маршрут сохранён',
            deleteConfirm: 'Удалить маршрут #{{id}}? Это действие нельзя отменить.',
            deleted: 'Маршрут удалён.',
            noCoordinatesToast: 'У этого места нет координат',
            alreadyInRoute: 'Уже в маршруте',
        },
        partner: {
            title: 'Партнёр',
            venue: 'Партнёр-площадка',
            author: 'Автор',
            noEmailYet: 'Email пока нет (приглашение в ожидании)',
            cityLabel: 'Город: {{city}}',
            addressLabel: 'Адрес: {{address}}',
            phoneLabel: 'Телефон: {{phone}}',
            websiteLabel: 'Сайт:',
            ratingLabel: 'Рейтинг: {{rating}}',
            reviewsCount: ' (отзывов: {{count}})',
            registered: 'Зарегистрирован: {{date}}',
            emailVerified: 'Email подтверждён: {{value}}',
            yes: 'да',
            no: 'нет',
            statsGames: 'Игры: {{count}}',
            statsSales: 'Продажи: {{amount}}',
            statsCommission: 'Комиссия: {{amount}}',
            statsQrScans: 'Сканирования QR: {{count}}',
            statsClaims: 'Клеймы: {{count}}',
            statsGuests: 'Гости с email: {{count}}',
            statsPurchases: 'Покупки: {{count}}',
            contactName: 'Контактное лицо',
            avatar: 'Аватар',
            avatarHint: 'Показывается рядом с именем автора в маршрутах и квестах.',
            companyName: 'Название компании',
            status: 'Статус',
            commissionPercent: 'Комиссия, %',
            discountPercent: 'Скидка гостю, %',
            discountPercentHint:
                'Скидка гостям, отсканировавшим QR площадки. Независима от комиссии. Действует только на новые сканы.',
            promocode: 'Промокод',
            inviteQr: 'QR-код приглашения',
            promoQr: 'Гостевой QR (для буклетов)',
            promoQrHint:
                'Печатается на маркетинговых материалах. Гость сканирует его для скидки; покупки атрибуцируются площадке.',
            noInviteToken: 'У этой площадки нет токена приглашения.',
            commissionRangeError: 'Комиссия должна быть числом от 0 до 100',
            discountRangeError: 'Скидка должна быть числом от 0 до 100',
            statusRequired: 'Статус обязателен',
            saved: 'Партнёр сохранён',
            deleteConfirm:
                'Удалить партнёра #{{id}}?\n\nЕсли есть связанные данные, установите статус «заблокирован» вместо удаления.',
            deleted: 'Партнёр удалён.',
        },
        partnerCreate: {
            newVenue: 'Новая площадка',
            newAuthor: 'Новый автор',
            newPartner: 'Новый партнёр',
            type: 'Тип',
            contactName: 'Контактное лицо',
            email: 'Email',
            passwordOptional: 'Пароль (необязательно)',
            passwordHint: 'Оставьте пустым для автогенерации временного пароля.',
            companyName: 'Название компании',
            commissionPercent: 'Комиссия %',
            tempPasswordNotice: 'Временный пароль (скопируйте сейчас): {{password}}',
            close: 'Закрыть',
            create: 'Создать',
            nameEmailRequired: 'Имя и email обязательны.',
            venueRequiresFields: 'Для площадки нужны название компании и город.',
            created: 'Партнёр создан.',
            temporaryPasswordTitle: 'Партнёр создан',
            temporaryPasswordMessage: 'Временный пароль: {{password}}',
        },
        materialOrder: {
            title: 'Заказ #{{id}}',
            fallbackTitle: 'Заказ материалов',
            venue: 'Площадка: {{name}}',
            quantity: 'Количество: {{count}}',
            address: 'Адрес: {{address}}',
            comment: 'Комментарий: {{comment}}',
            status: 'Статус',
            trackingInfo: 'Информация о доставке',
            save: 'Сохранить',
            cancel: 'Отмена',
            updated: 'Заказ обновлён',
        },
        cityCreate: {
            title: 'Новый город',
            titleField: 'Название',
            titlePlaceholder: 'напр. Мюнхен',
            country: 'Страна',
            create: 'Создать город',
            titleCountryRequired: 'Название и страна обязательны.',
            created: 'Город создан: {{title}} (#{{id}})',
        },
        questCreate: {
            title: 'Новый квест',
            titleField: 'Название',
            tagline: 'Тизер',
            originalLanguage: 'Исходный язык',
            originalLanguageHint: 'Точки и тексты сначала создаются на этом языке.',
            author: 'Автор',
            authorHint: 'Автор портала, которому принадлежит этот квест.',
            create: 'Создать квест',
            titleCityRequired: 'Название и город обязательны.',
            created: 'Квест создан.',
        },
        authorSelect: {
            label: 'Автор',
            placeholder: 'Выберите автора',
            noAuthor: 'Без автора',
            loading: 'Загрузка…',
            noAuthorsFound: 'Авторы не найдены',
        },
        citySearchSelect: {
            label: 'Город',
            placeholder: 'Поиск городов…',
            searching: 'Поиск…',
            noCitiesFound: 'Города не найдены',
        },
        quest: {
            fallbackTitle: 'Квест',
            fallbackTitleId: 'Квест #{{id}}',
            tabs: {
                meta: 'Мета',
                constructor: 'Конструктор',
                locales: 'Локали',
            },
            delete: 'Удалить',
            deleteConfirm: 'Удалить квест {{key}}?\n\nЭто действие нельзя отменить.',
            deleted: 'Квест удалён.',
            overview: {
                cover: {
                    title: 'Обложка',
                    description: 'Показывается в каталоге игрока и в списке админки.',
                },
                catalog: {
                    title: 'Каталог',
                    description: 'Видимость и размещение в каталоге игрока.',
                    status: 'Статус',
                    primaryLanguage: 'Основной язык',
                    primaryLanguageHint: 'Язык, на котором был создан квест.',
                    author: 'Автор',
                    authorHint: 'Автор портала, которому принадлежит этот квест.',
                    displayType: 'Формат для витрин',
                    displayTypeHint:
                        'Как игру назвать во внешних каталогах: городской квест, прогулка с гидом или мистическая прогулка.',
                    navigatorQuestroomId: 'ID квеста в Escape Navigator',
                    navigatorQuestroomIdHint:
                        'ID листинга в каталоге Escape Navigator. Его страница берёт у нас параметры маршрута и цену.',
                    rejectionReason: 'Причина отклонения',
                },
                routeFacts: {
                    title: 'Параметры маршрута',
                    description: 'Не зависящие от языка числа, показанные рядом с названием.',
                    distance: 'Расстояние, км',
                    duration: 'Длительность, минут',
                    durationMin: 'Длительность мин',
                    durationMax: 'Длительность макс',
                },
                markReady: 'Отметить готовым',
                markReadyConfirm:
                    'Отметить этот квест как готовый? Он станет виден в каталоге игрока.',
                statusRequired: 'Статус обязателен.',
                saved: 'Квест сохранён.',
                markedReady: 'Квест отмечен готовым.',
                validate: 'Проверить',
                validation: {
                    title: 'Проверка',
                    description: 'Готовность к публикации; статус не меняется.',
                    noIssues: 'Проблем не найдено.',
                    playableLanguages: 'Играбельные языки:',
                    nonePlayable: 'нет',
                },
            },
            locales: {
                catalogCopy: {
                    title: 'Текст для каталога',
                    description:
                        'Название и тизер в каталоге игрока. Пролог и финал редактируются в Конструкторе.',
                    titleField: 'Название',
                    tagline: 'Тизер',
                    voicedBy: 'Озвучил(а)',
                    voicedByHint: 'Рассказчик, указанный для этого языка.',
                    localeStatus: 'Статус локали',
                },
                prologue: {
                    title: 'Пролог',
                    description: 'Экраны, показываемые перед первой точкой.',
                    key: 'Ключ',
                    text: 'Текст',
                    addScreen: 'Добавить экран',
                    audioUrl: 'Аудио пролога (URL)',
                },
                finale: {
                    title: 'Финал',
                    description: 'Концовки и мета-загадка.',
                    choicePrompt: 'Текст выбора',
                    id: 'Id',
                    label: 'Подпись',
                    ending: 'Концовка',
                    addEnding: 'Добавить концовку',
                    finalPuzzlePrompt: 'Текст финальной загадки',
                    finalPuzzleAnswers: 'Ответы на финальную загадку (через запятую)',
                    finalPuzzleHint: 'Подсказка финальной загадки {{n}}',
                    addFinalPuzzleHint: 'Добавить подсказку финальной загадки',
                    finalPuzzleExplanation: 'Объяснение решения финальной загадки',
                    audioUrl: 'Аудио финала (URL)',
                },
                generateTts: 'Озвучить (TTS)',
                audioGenerated: 'Аудио сгенерировано и сохранено в локаль.',
                titleRequired: 'Название обязательно для локали.',
                saved: 'Локаль сохранена.',
                saveLocale: 'Сохранить локаль',
                saveMarkReviewed: 'Сохранить и отметить проверенным',
            },
            constructor: {
                searchPlaceholder: 'Поиск по карте…',
                placesStopsCount: 'мест: {{places}} · точек: {{stops}}',
                stopsTitle: 'Маршрут',
                stopsDescription:
                    'Пролог → точки → финал. Перетаскиваются только нумерованные точки.',
                bookendPrologue: 'Пролог',
                bookendFinale: 'Финал',
                bookendFixed: 'Закреплено',
                noStops: 'Точек пока нет — добавьте достопримечательности с карты.',
                milestone: 'веха',
                noText: 'нет текста',
                newBadge: 'новая',
                addToQuest: 'Добавить в квест',
                selectStopOrAttraction:
                    'Выберите пролог, точку, финал или достопримечательность на карте',
                stopFallback: 'Точка {{id}}',
                place: {
                    title: 'Место',
                    description: 'Достопримечательность и GPS-отметка.',
                    attraction: 'Достопримечательность',
                    noAddress: 'Нет адреса',
                    gpsRadius: 'Радиус GPS (м)',
                    keyMilestone: 'Ключевая веха (показывается в превью маршрута)',
                },
                stopPhoto: {
                    title: 'Фото точки',
                    description: 'Необязательно. Пусто — используется фото достопримечательности.',
                },
                challengeMechanics: {
                    title: 'Механика задания',
                    description: 'Тип и подсчёт очков. Текст задания/ответы — на язык ниже.',
                    type: 'Тип',
                    choiceIds: 'ID вариантов (через запятую)',
                    choiceIdsHint: 'Подписи переводятся отдельно на каждый язык ниже.',
                    doneAnswerNote:
                        'Служебный ответ «done» добавляется в принимаемые ответы автоматически при сохранении.',
                    sensorKind: 'Вид сенсора',
                    sensorDuration: 'Длительность удержания (сек)',
                    sensorTargetHeading: 'Азимут цели (°)',
                    sensorTolerance: 'Допуск (°)',
                    dynamicRule: 'Правило динамического ответа',
                    dynamicRuleHint: 'Сервер проверяет ответ в момент отправки.',
                    dynamicTolerance: 'Допуск',
                    dynamicToleranceHint: 'Например, plus_minus_10_minutes.',
                    photoCollageSlot: 'Слот фотоколлажа',
                    photoCollageSlotHint: 'Позиция этого фото в финальном коллаже.',
                    arHunt: {
                        collectRadius: 'Радиус сбора по умолчанию (м)',
                        symbols: 'AR-символы',
                        symbolId: 'Id',
                        glyph: 'Глиф',
                        lat: 'Широта',
                        lng: 'Долгота',
                        radius: 'Радиус (м)',
                        spriteUrl: 'Спрайт (URL, приоритетнее глифа)',
                        anchorImageUrl: 'Эталонное фото (URL)',
                        anchorImageUrlHint:
                            'Фото поверхности для image tracking; пусто — компасный AR.',
                        addSymbol: 'Добавить символ',
                    },
                    expectedSolveTime: 'Ожидаемое время решения (сек)',
                    telemetryKey: 'Ключ события телеметрии',
                },
                hintPenalties: {
                    title: 'Штрафы за подсказки',
                    description: 'Уровень и штраф очков; текст — на язык ниже.',
                    level: 'уровень {{n}}',
                    penalty: 'Штраф',
                    addLevel: 'Добавить уровень подсказки',
                },
                stopTexts: {
                    title: 'Тексты точки',
                    description: 'Текст на {{lang}}. Название для каталога — на вкладке Локали.',
                    needsPromptHint:
                        'Текст задания и ответы обязательны, чтобы точка была играбельна на {{lang}}.',
                    chapterTitle: 'Название главы',
                    nameBeforeSolving: 'Название до решения',
                    fromPrevious: 'От предыдущей точки',
                    walkMicroTask: 'Микро-задание по пути',
                    arrivalInstruction: 'Инструкция по прибытию',
                    storyBefore: 'История до',
                    challengePrompt: 'Текст задания · {{type}}',
                    acceptedAnswers: 'Принимаемые ответы (через запятую)',
                    acceptedAnswersHint: 'Ответы зависят от языка.',
                    choiceLabels: 'Подписи вариантов',
                    hintLevel: 'Подсказка уровня {{level}} (−{{penalty}})',
                    solutionExplanation: 'Объяснение решения',
                    storyAfter: 'История после',
                    historicalNote: 'Историческая справка',
                    metaToken: 'Токен мета-загадки',
                    metaTokenHint: 'Буква или символ, который даёт эта точка на этом языке.',
                    sensorActionLabel: 'Подпись действия сенсора',
                    sensorSuccessText: 'Текст успеха сенсора',
                    arHuntSuccessText: 'Текст успеха AR-охоты',
                    arHuntTargetHint: 'Подпись цели · {{id}}',
                    photoChallengePrompt: 'Текст фото-задания',
                    photoExpected: 'Проверка фото: что должно быть на снимке',
                    photoExpectedHint:
                        'Критерий для vision-модели. Пусто — фото принимается на честность.',
                    photoMinConfidence: 'Проверка фото: порог уверенности (0–1)',
                    cipher: {
                        kind: 'Вид шифра',
                        ciphertext: 'Шифртекст',
                        shift: 'Сдвиг',
                        alphabet: 'Алфавит',
                        alphabetHint: 'Алфавит колеса; пусто — латиница A–Z.',
                        symbolMap: 'Подстановка (символ → буква)',
                        symbol: 'Символ',
                        letter: 'Буква',
                        revealedPairs: 'Открытых пар',
                        addPair: 'Добавить пару',
                    },
                    storyAudioUrl: 'Аудио истории (URL)',
                    walkAudioUrl: 'Аудио по пути (URL)',
                    challengeAudioUrl: 'Аудио задания (URL)',
                    generateTts: 'Озвучить (TTS)',
                    generateTtsSaveFirst: 'Сначала сохраните точки — тогда появится озвучка.',
                    audioGenerated: 'Аудио сгенерировано и сохранено в локаль.',
                },
                extras: {
                    title: 'Дополнительно',
                    description:
                        'Необязательные медиа и побочный контент. Тексты — на {{lang}}, медиа общее.',
                    thenPhoto: {
                        title: 'Фото «тогда/сейчас»',
                        photo: 'Историческое фото',
                        year: 'Год',
                        caption: 'Подпись',
                    },
                    video: {
                        title: 'Видео',
                        url: 'Видео (URL)',
                        posterUrl: 'Постер (URL)',
                    },
                    evidence: {
                        title: 'Улика',
                        image: 'Картинка улики',
                        id: 'Id',
                        idHint: 'Стабильный ключ улики внутри квеста.',
                        evidenceTitle: 'Название',
                        description: 'Описание',
                    },
                    bonusSecret: {
                        title: 'Бонус-секрет',
                        points: 'Бонусные очки',
                        teaser: 'Намёк',
                        teaserHint: 'Ненавязчивый намёк, что есть секрет. Пусто — полностью скрыт.',
                        prompt: 'Задание',
                        acceptedAnswers: 'Принимаемые ответы (через запятую)',
                        hint: 'Подсказка',
                        solutionExplanation: 'Объяснение решения',
                    },
                    teamSplit: {
                        title: 'Роли для команды',
                        role: 'Роль',
                        task: 'Задача',
                        addRole: 'Добавить роль',
                    },
                    fallback: {
                        title: 'Fallback',
                        prompt: 'Запасной текст задания',
                        acceptedAnswers: 'Запасные принимаемые ответы (через запятую)',
                    },
                },
                routeEvents: {
                    title: 'События маршрута',
                    description:
                        'Вставки между точками на {{lang}}: сообщение или бонус после решения выбранной точки.',
                    untitledEvent: 'Событие без названия',
                    key: 'Ключ',
                    type: 'Тип',
                    afterStop: 'После точки',
                    afterStopShort: 'после {{n}}',
                    afterStopsCompleted: 'После N закрытых точек',
                    afterStopsCompletedHint:
                        'Для квестов со свободным порядком; альтернативный триггер.',
                    afterStopsCompletedShort: 'после {{n}} точек',
                    noTrigger: 'без триггера',
                    bonus: 'Бонус',
                    timer: 'Таймер (сек)',
                    challenge: 'Задание',
                    from: 'От',
                    text: 'Текст',
                    challengePrompt: 'Текст задания · {{type}}',
                    acceptedAnswers: 'Принимаемые ответы (через запятую)',
                    solutionExplanation: 'Объяснение решения',
                    chase: {
                        duration: 'Длительность погони (сек)',
                        spawnDistance: 'Стартовая дистанция (м)',
                        catchRadius: 'Радиус поимки (м)',
                        targetSpeed: 'Скорость цели (м/с)',
                        targetLabel: 'Подпись цели',
                        successText: 'Текст успеха',
                        failText: 'Текст провала',
                    },
                    audioUrl: 'Аудио (URL)',
                    addEvent: 'Добавить событие маршрута',
                },
                atLeastOneStop: 'В квесте должна быть хотя бы одна точка.',
                eventNoTrigger:
                    'У события маршрута «{{key}}» нет триггера (точки или счётчика закрытых точек).',
                removeStopConfirm:
                    'Удалить точку «{{title}}»?\n\nЕё тексты на всех языках будут удалены при сохранении.',
                removeStopEventsWarning: '\nБудет отвязано событий маршрута: {{count}}.',
                stopsSaved: 'Точки сохранены.',
                saveStops: 'Сохранить точки',
            },
        },
    },
    layout: {
        admin: 'Админ',
        logout: 'Выйти',
        noAccess: 'Нет доступа',
        noPermission: 'У вас нет прав на этот раздел.',
        brand: 'Routellers',
    },
    pagination: {
        range: '{{from}}–{{to}} из {{total}}',
    },
    pipeline: {
        cityTools: 'Инструменты города',
        help: {
            processCity:
                'Запускает фоновую обработку города: импорт и поиск мест, автоматический отбор, обогащение карточек и связи с персонами. Перед запуском отдельно выбирается генерация русских AI-текстов. Процесс меняет данные и использует платные AI-запросы.',
            autolink:
                'Связывает уже имеющихся персон с местами города по Wikidata. Затем AI дополняет связи для персон города без связей. Создаёт записи связей и может использовать платные AI-запросы.',
            gapAudit:
                'Ищет отсутствующие в базе места по путеводителям, турам и Wikivoyage. Использует AI и веб-поиск; найденные кандидаты добавляются на проверку. Запуск меняет каталог.',
            stop: 'Отменяет дальнейшие шаги фоновой обработки. Уже выполненные изменения сохраняются; текущая операция может закончиться до остановки.',
        },
        promptCityId: 'ID города для обработки:',
        processCity: 'Обработать город',
        processingStatus: '{{city}}: {{stage}}',
        starting: 'запуск',
        autolink: 'Автосвязка',
        stop: 'Остановить',
        lastRun: 'Последний: #{{id}} {{status}}',
        running: 'Выполняется…',
        contentConfirm:
            'Также сгенерировать AI-тексты на RU?\n\nОтмена — только каркас: импорт → исследование → сортировка → обогащение → автосвязка.\n\nOK — черновые AI-тексты (RU) для мест без контента (дольше, платно через OpenAI). EN не генерируется. Существующие тексты никогда не перезаписываются.',
        started: 'Пайплайн #{{id}} запущен для {{city}}',
        stopConfirm: 'Остановить пайплайн #{{id}} ({{city}})?',
        cancelled: 'Пайплайн отменён',
        autolinkConfirm:
            'Связать персон с достопримечательностями города #{{cityId}}? Сначала Wikidata, затем AI для персон без связей. Новые связи сохранятся в базе; возможны платные AI-запросы.',
        gapAudit: 'Найти пропущенные места',
        gapAuditRunning: 'Ищем пропущенные места…',
        gapAuditConfirm:
            'Найти места города #{{cityId}}, которых нет в базе? Модель с веб-поиском по путеводителям и турам плюс все достопримечательности Wikivoyage по районам; места без истории отсеиваются, найденные добавятся на проверку (needReview). 2–5 минут.',
        gapAuditTitle: 'Пропущенные места: {{city}}',
        gapAuditResult:
            'Кандидатов {{listed}}, уже в базе {{existing}}, добавлено {{created}}, без координат {{unverified}}, отсеяно {{skipped}}',
        gapAuditCreated: 'Добавлены',
        gapAuditUnverified: 'Проверить вручную',
        autolinkResult:
            'Автосвязка: +{{created}} связей · уже было {{already}} · просканировано персон: {{persons}} / мест: {{attractions}}',
        processedTitle: '{{city}} обработан',
        stoppedTitle: 'Пайплайн остановлен',
        unknownError: 'Неизвестная ошибка',
        done: 'Готово',
    },
    components: {
        helpHint: 'Подсказка: {{subject}}',
        mediaDropzone: {
            uploadFile: 'Загрузить файл',
            replaceMedia: 'Заменить медиа',
            removeMedia: 'Удалить медиа',
            orPasteUrl: 'Или вставьте URL',
            unsupportedFile: 'Неподдерживаемый файл. Используйте изображение, аудио или видео.',
        },
        coverUpload: {
            dropHere: 'Перетащите обложку сюда',
            orClickToBrowse: 'или нажмите, чтобы выбрать',
            uploading: 'Загрузка…',
            replace: 'Заменить',
            remove: 'Удалить',
            viewFullSize: 'Открыть полностью',
            orPasteUrl: 'Или вставьте URL изображения',
            dropImageFile: 'Перетащите файл изображения.',
        },
        imageLightbox: {
            defaultTitle: 'Фото',
            alt: 'Фото в полном размере',
            close: 'Закрыть',
            previous: 'Предыдущее фото',
            next: 'Следующее фото',
        },
        photoUpload: {
            dropOrClick: 'Перетащите или кликните',
            squarePhotoHint: 'Лучше всего подходит квадратное фото. JPG, PNG или WebP.',
            orPasteImageUrl: 'Или вставьте URL изображения',
            replace: 'Заменить',
            remove: 'Удалить',
            cover: 'Обложка',
            setAsCover: 'Сделать обложкой',
            dropPhotosHere: 'Перетащите фото сюда',
            uploading: 'Загрузка…',
            orClickToBrowse: 'или кликните для выбора',
            orPasteUrlEnter: 'Или вставьте URL изображения и нажмите Enter',
            maxPhotos: 'Максимум {{max}} фото.',
            dropImageFile: 'Пожалуйста, перетащите файл изображения.',
            dropImageFiles: 'Пожалуйста, перетащите файлы изображений.',
            photos: 'Фото',
            addUrl: 'Добавить URL',
            urlUnreadable: 'Не удалось прочитать изображение по этой ссылке.',
        },
        entityEditorShell: {
            unsavedChangesClose: 'Есть несохранённые изменения. Всё равно закрыть?',
            unsaved: 'Не сохранено',
        },
        requirePermission: {
            noAccess: 'Нет доступа',
            noAccessHint: 'У вас нет прав на этот раздел.',
        },
        attractionPhotos: {
            defaultTitle: 'Фото',
            alt: 'Фото достопримечательности',
            close: 'Закрыть',
            previousPhoto: 'Предыдущее фото',
            nextPhoto: 'Следующее фото',
        },
        languageSwitcher: {
            ariaLabel: 'Язык',
        },
        cityQuickSelect: {
            allCities: 'Все города',
            placeholder: 'Город',
            nothingFound: 'Города не найдены',
        },
        countrySelect: {
            allCountries: 'Все страны',
            placeholder: 'Страна',
            nothingFound: 'Страны не найдены',
        },
    },
} as const;
